var _path, _path2, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _polygon58, _polygon59, _polygon60, _polygon61, _polygon62, _polygon63, _polygon64, _polygon65, _polygon66, _polygon67, _polygon68, _polygon69;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeliveryaddressAmico(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Buildings--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--buildings--inject-11",
    d: "M463.74,196.45l-8.26,4.77V181.56l-4.13-2.38-8.26,4.76v3.69l-8.26,4.77V171.89l-8.26-4.76-8.26,4.76V174l-8.26,4.77V152.87l-8.26-4.77-8.26,4.77V139.42l-8.26-4.77-12.39,7.15v4.77l-8.26,4.77v3.91l-8.26-4.76V133.86s-8.11-4.53-8.26-4.53-8.26,4.53-8.26,4.53V141l-8.26-4.77L323.32,141v9.54l-8.26,4.76V131.08l-4.12-2.39-4.13,2.39v9.53l-4.13-2.38L294.42,143v-7.27l-4.13-2.38L282,138.12v12l-4.13-2.38V143l-8.26-4.77L261.38,143v-4.77L249,131.07l-8.26,4.77V126.3l-8.26-4.76-8.26,4.76v13.26l-4.13,2.38v-9.53l-8.26-4.77-8.26,4.77v14.3l-12.39-7.15V130l-8.26-4.77L174.65,130v14.31l-4.13-2.39-8.25,4.77v5.82L154,157.3v-8.88l-8.26-4.77-12.39,7.15v-7.66l-8.26-4.77-12.39,7.15V161l-12.39-7.16L83.8,163.39v-7.81l-8.26-4.77-8.26,4.77v14.34L59,174.68v8.11L46.63,190v-5.19L38.37,180,26.59,186.8V307.55H473.41V202Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Streetlights--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--city-lights--inject-11"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.56,304.13a1,1,0,0,0,1-1V106.71a12.35,12.35,0,0,1,5.49-9.5L49,88c1.27-.73,2.41-.88,3.21-.42s1.24,1.52,1.24,3v19.09a1,1,0,1,0,2.08,0V90.56c0-2.24-.81-3.94-2.28-4.79s-3.35-.7-5.29.42L32.05,95.41a14.23,14.23,0,0,0-6.53,11.3V303.09A1,1,0,0,0,26.56,304.13Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.06,105.2a8.35,8.35,0,0,1,7.51,0,2.66,2.66,0,0,1,1.55,2.17v1.53a2.64,2.64,0,0,1-1.55,2.17,8.28,8.28,0,0,1-7.51,0,2.64,2.64,0,0,1-1.56-2.17v-1.53A2.65,2.65,0,0,1,51.06,105.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.06,106.74c-2.08,1.2-2.08,3.14,0,4.34a8.35,8.35,0,0,0,7.51,0c2.07-1.2,2.07-3.14,0-4.34A8.28,8.28,0,0,0,51.06,106.74Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.64,121.48H60V109.42a2.56,2.56,0,0,0-1.51-2.11,8.13,8.13,0,0,0-7.32,0,2.56,2.56,0,0,0-1.51,2.11h0Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.64,121.48H60V109.42a2.56,2.56,0,0,0-1.51-2.11,8.13,8.13,0,0,0-7.32,0,2.56,2.56,0,0,0-1.51,2.11h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.47,123.59c2-1.17,2-3.06,0-4.23a8.13,8.13,0,0,0-7.32,0c-2,1.17-2,3.06,0,4.23A8.13,8.13,0,0,0,58.47,123.59Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.47,123.59c2-1.17,2-3.06,0-4.23a8.13,8.13,0,0,0-7.32,0c-2,1.17-2,3.06,0,4.23A8.13,8.13,0,0,0,58.47,123.59Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7,111.16a3.11,3.11,0,1,1,3.11,3.11A3.11,3.11,0,0,1,51.7,111.16Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.64,114.87a6.35,6.35,0,0,0,10.34,0v-5.45a2.56,2.56,0,0,0-1.51-2.11,8.13,8.13,0,0,0-7.32,0,2.56,2.56,0,0,0-1.51,2.11Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.37,111.16a1.45,1.45,0,1,1,1.44,1.45A1.44,1.44,0,0,1,53.37,111.16Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.06,118.85a8.35,8.35,0,0,1,7.51,0A2.66,2.66,0,0,1,60.12,121v1.54a2.63,2.63,0,0,1-1.55,2.16,8.28,8.28,0,0,1-7.51,0,2.62,2.62,0,0,1-1.56-2.16V121A2.65,2.65,0,0,1,51.06,118.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.06,120.39c-2.08,1.2-2.08,3.14,0,4.33a8.28,8.28,0,0,0,7.51,0c2.07-1.19,2.07-3.13,0-4.33A8.28,8.28,0,0,0,51.06,120.39Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--city-lights--inject-11"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M473.47,304.13a1,1,0,0,1-1-1V106.71a12.32,12.32,0,0,0-5.49-9.5L451,88c-1.27-.73-2.41-.88-3.21-.42s-1.24,1.52-1.24,3v19.09a1,1,0,0,1-2.08,0V90.56c0-2.24.81-3.94,2.28-4.79s3.35-.7,5.29.42L468,95.41a14.23,14.23,0,0,1,6.53,11.3V303.09A1,1,0,0,1,473.47,304.13Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M449,105.2a8.35,8.35,0,0,0-7.51,0,2.65,2.65,0,0,0-1.56,2.17v1.53a2.64,2.64,0,0,0,1.56,2.17,8.28,8.28,0,0,0,7.51,0,2.64,2.64,0,0,0,1.55-2.17v-1.53A2.66,2.66,0,0,0,449,105.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,106.74c2.07,1.2,2.07,3.14,0,4.34a8.35,8.35,0,0,1-7.51,0c-2.08-1.2-2.08-3.14,0-4.34A8.28,8.28,0,0,1,449,106.74Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.39,121.48H440.05V109.42a2.56,2.56,0,0,1,1.51-2.11,8.13,8.13,0,0,1,7.32,0,2.56,2.56,0,0,1,1.51,2.11h0Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.39,121.48H440.05V109.42a2.56,2.56,0,0,1,1.51-2.11,8.13,8.13,0,0,1,7.32,0,2.56,2.56,0,0,1,1.51,2.11h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.56,123.59c-2-1.17-2-3.06,0-4.23a8.13,8.13,0,0,1,7.32,0c2,1.17,2,3.06,0,4.23A8.13,8.13,0,0,1,441.56,123.59Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.56,123.59c-2-1.17-2-3.06,0-4.23a8.13,8.13,0,0,1,7.32,0c2,1.17,2,3.06,0,4.23A8.13,8.13,0,0,1,441.56,123.59Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.33,111.16a3.11,3.11,0,1,0-3.11,3.11A3.1,3.1,0,0,0,448.33,111.16Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.39,114.87a6.35,6.35,0,0,1-10.34,0v-5.45a2.56,2.56,0,0,1,1.51-2.11,8.13,8.13,0,0,1,7.32,0,2.56,2.56,0,0,1,1.51,2.11Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.66,111.16a1.44,1.44,0,1,0-1.44,1.45A1.44,1.44,0,0,0,446.66,111.16Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,118.85a8.35,8.35,0,0,0-7.51,0,2.65,2.65,0,0,0-1.56,2.17v1.54a2.62,2.62,0,0,0,1.56,2.16,8.28,8.28,0,0,0,7.51,0,2.63,2.63,0,0,0,1.55-2.16V121A2.66,2.66,0,0,0,449,118.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,120.39c2.07,1.2,2.07,3.14,0,4.33a8.28,8.28,0,0,1-7.51,0c-2.08-1.19-2.08-3.13,0-4.33A8.28,8.28,0,0,1,449,120.39Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-11",
    d: "M77.67,251.7c-95.18,54.95-95.18,144,0,199s249.49,54.94,344.66,0,95.18-144,0-199S172.84,196.75,77.67,251.7Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-11",
    d: "M293,468.7c12.79,7.38,47.69-1.19,78-19.14l58.94-34.95c30.27-18,45-38.2,32.81-45.22S416,371,385.51,388.56L325,423.47C294.55,441.07,280.21,461.32,293,468.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-11",
    d: "M193.15,478.32l85.79-49.52a.66.66,0,0,0,0-1.25l-50.27-29a2.35,2.35,0,0,0-2.16,0l-85.8,49.53a.66.66,0,0,0,0,1.25l50.28,29A2.35,2.35,0,0,0,193.15,478.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-11",
    points: "292.96 333.32 186.4 271.68 44.08 353.94 150.64 415.46 235.59 366.43 253.37 376.7 284.27 358.87 266.49 348.6 292.96 333.32",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-11",
    points: "89.08 385.01 39.64 413.55 101.55 449.37 150.98 420.75 89.08 385.01",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clouds--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.77,39.46l-3.31,1.27V33.44c0-5.77-4.61-7.16-9.61-4.27h0c-5,2.89-9.06,9.92-9.06,15.69v1.06a4.9,4.9,0,0,0-4.21.65h0a14.42,14.42,0,0,0-6.52,11.3v.48L24.45,61a9.5,9.5,0,0,0-4.3,7.44c0,2.74,1.93,3.85,4.3,2.48L61.77,49.38a9.5,9.5,0,0,0,4.3-7.44C66.07,39.2,64.14,38.09,61.77,39.46Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.43,44.33l-6,3.47a7.31,7.31,0,0,0,0-.8V45.26c0-3.09-2.17-4.34-4.85-2.8a9.52,9.52,0,0,0-2.89,2.78c-.44-3.89-3.49-5.33-7.19-3.2a16,16,0,0,0-7.26,12.57v2.6a6.71,6.71,0,0,0,.62,3l-5,2.88a6,6,0,0,0-2.69,4.66c0,1.71,1.21,2.41,2.69,1.55l32.51-18.77a5.92,5.92,0,0,0,2.69-4.66C106.12,44.17,104.92,43.47,103.43,44.33Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.24,56l-6,3.46a7.13,7.13,0,0,0,.05-.79V57c0-3.09-2.17-4.35-4.85-2.8A9.18,9.18,0,0,0,252.56,57c-.44-3.89-3.49-5.34-7.2-3.2a16,16,0,0,0-7.25,12.57v2.6a6.92,6.92,0,0,0,.61,3l-5,2.87a6,6,0,0,0-2.69,4.66c0,1.72,1.2,2.41,2.69,1.56l32.5-18.77a5.93,5.93,0,0,0,2.69-4.66C268.93,55.87,267.73,55.18,266.24,56Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--clouds--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444.68,42.29,448,43.57V36.28c0-5.78,4.61-7.17,9.61-4.28h0c5,2.89,9.06,9.92,9.06,15.7v1a4.9,4.9,0,0,1,4.21.65h0a14.42,14.42,0,0,1,6.52,11.3v.48L482,63.84a9.5,9.5,0,0,1,4.3,7.44c0,2.74-1.93,3.85-4.3,2.48L444.68,52.21a9.48,9.48,0,0,1-4.3-7.44C440.38,42,442.3,40.92,444.68,42.29Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,47.16l6,3.47a7.31,7.31,0,0,1,0-.8V48.09c0-3.09,2.17-4.34,4.85-2.8a9.52,9.52,0,0,1,2.89,2.78c.43-3.88,3.49-5.33,7.19-3.19a16,16,0,0,1,7.26,12.56V60a6.85,6.85,0,0,1-.62,3l5,2.88a6,6,0,0,1,2.69,4.66c0,1.72-1.21,2.41-2.69,1.55L403,53.38a6,6,0,0,1-2.69-4.66C400.33,47,401.53,46.31,403,47.16Z",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tree--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--tree--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--tree--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.17,321a4.52,4.52,0,0,1,2.43.43,24.73,24.73,0,0,1,4,2.81,8.1,8.1,0,0,0,4.4,1.9,3.55,3.55,0,0,0,3.66-2.55,2.47,2.47,0,0,1,.2-.82,1.18,1.18,0,0,1,1.39-.35,7.08,7.08,0,0,1,1.33.77c1.64,1,3.7.75,5.58.47,1.57-.23,3.54-.92,3.54-2.5,0-1-.91-1.8-1.62-2.55s-1.29-2-.63-2.75a1.84,1.84,0,0,1,.9-.56c2-.64,4.36.21,6-1a3.45,3.45,0,0,0,.87-4.15,5.25,5.25,0,0,0-3.53-2.69c-1.31-.33-3-.49-3.47-1.76-.43-1.11.43-2.3,1.4-3a10.22,10.22,0,0,0,2.83-2.13,3.38,3.38,0,0,0,.09-3.51,4.28,4.28,0,0,0-2.95-2,6.36,6.36,0,0,1-1.79-.39,1.19,1.19,0,0,1-.66-1.51c.17-.32.55-.49.76-.79a1.43,1.43,0,0,0-.53-1.87,7.53,7.53,0,0,0-2-.76c-1.42-.48-2.15-1.23-1.73-2.66s2.46-1.39,3.07-2.83c.53-1.27-.94-4-2.08-4.75a26.17,26.17,0,0,0-3.78-1.68,4,4,0,0,1-2.55-3c-.11-1.41.95-2.6,1.81-3.72s1.6-2.68.84-3.88-2.33-1.22-3.62-1.63a5.84,5.84,0,0,1-3.57-3.22c-.35-.8-.52-1.67-.93-2.43-1.28-2.37-4.51-3.41-7-3.12a2.85,2.85,0,0,0-2.39,1.62,3.86,3.86,0,0,0-.87,1.64c-.19,1.15.42,2.61-.66,3.48-1.65,1.33-4.16-.46-4.07,2.51a12.58,12.58,0,0,0,.55,3.71c.45,1.24,1.34,1.79.6,3.18-1,1.82-1.6,1.81-3.53,1.8-1.4,0-2.57-.07-3.6,1-1.8,1.86-.73,3.55.88,5,1.82,1.64.85,2.35.61,4.48-.11,1,.12,1.33-.79,2-1.73,1.28-2.69.85-2.2,3.35.44,2.29-.24,1.51-2.23,2.36-1.76.76-2.92,2.65-4.35,3.84-.91.76-2.31,1.34-2.39,2.68-.17,2.55,3,2,4.51,2.6,2.47,1,1.74,4.23-.19,5.44s-5,1.76-5.17,4.68c-.13,2.25,1.14,2.74,2.88,3.49,1.39.6,1.22.78,1.21,2.43,0,3.35,1.13,4.29,4.42,3.75a8.2,8.2,0,0,1,3.18-.26c1.27.38.84.69.88,1.74.09,2.7,3.23,1.94,4.56.79C22.16,322.73,24.09,321.19,26.17,321Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.17,321a4.52,4.52,0,0,1,2.43.43,24.73,24.73,0,0,1,4,2.81,8.1,8.1,0,0,0,4.4,1.9,3.55,3.55,0,0,0,3.66-2.55,2.47,2.47,0,0,1,.2-.82,1.18,1.18,0,0,1,1.39-.35,7.08,7.08,0,0,1,1.33.77c1.64,1,3.7.75,5.58.47,1.57-.23,3.54-.92,3.54-2.5,0-1-.91-1.8-1.62-2.55s-1.29-2-.63-2.75a1.84,1.84,0,0,1,.9-.56c2-.64,4.36.21,6-1a3.45,3.45,0,0,0,.87-4.15,5.25,5.25,0,0,0-3.53-2.69c-1.31-.33-3-.49-3.47-1.76-.43-1.11.43-2.3,1.4-3a10.22,10.22,0,0,0,2.83-2.13,3.38,3.38,0,0,0,.09-3.51,4.28,4.28,0,0,0-2.95-2,6.36,6.36,0,0,1-1.79-.39,1.19,1.19,0,0,1-.66-1.51c.17-.32.55-.49.76-.79a1.43,1.43,0,0,0-.53-1.87,7.53,7.53,0,0,0-2-.76c-1.42-.48-2.15-1.23-1.73-2.66s2.46-1.39,3.07-2.83c.53-1.27-.94-4-2.08-4.75a26.17,26.17,0,0,0-3.78-1.68,4,4,0,0,1-2.55-3c-.11-1.41.95-2.6,1.81-3.72s1.6-2.68.84-3.88-2.33-1.22-3.62-1.63a5.84,5.84,0,0,1-3.57-3.22c-.35-.8-.52-1.67-.93-2.43-1.28-2.37-4.51-3.41-7-3.12a2.85,2.85,0,0,0-2.39,1.62,3.86,3.86,0,0,0-.87,1.64c-.19,1.15.42,2.61-.66,3.48-1.65,1.33-4.16-.46-4.07,2.51a12.58,12.58,0,0,0,.55,3.71c.45,1.24,1.34,1.79.6,3.18-1,1.82-1.6,1.81-3.53,1.8-1.4,0-2.57-.07-3.6,1-1.8,1.86-.73,3.55.88,5,1.82,1.64.85,2.35.61,4.48-.11,1,.12,1.33-.79,2-1.73,1.28-2.69.85-2.2,3.35.44,2.29-.24,1.51-2.23,2.36-1.76.76-2.92,2.65-4.35,3.84-.91.76-2.31,1.34-2.39,2.68-.17,2.55,3,2,4.51,2.6,2.47,1,1.74,4.23-.19,5.44s-5,1.76-5.17,4.68c-.13,2.25,1.14,2.74,2.88,3.49,1.39.6,1.22.78,1.21,2.43,0,3.35,1.13,4.29,4.42,3.75a8.2,8.2,0,0,1,3.18-.26c1.27.38.84.69.88,1.74.09,2.7,3.23,1.94,4.56.79C22.16,322.73,24.09,321.19,26.17,321Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.31,315.29c1.51-.49,3.27-.1,4.75-.45a16.69,16.69,0,0,0-2.66-.42,7.52,7.52,0,0,0-5.75,2.28,5.15,5.15,0,0,1,1.16,3.45c-3.73,1-7.41-4-11-2.48.22,1.81,0,4.24-1.75,4.64A2.86,2.86,0,0,1,33.37,321c-.64-.84-1-1.86-1.68-2.7a5.73,5.73,0,0,0-7.6-1.1c-1,.69-2.17,1.75-3.13,1.05s-.41-2.78-1.55-3.35c-.76-.38-1.82.22-2.46-.34a1.71,1.71,0,0,1-.43-.93c-.46-1.91-.85-4.11.35-5.66,1.07-1.38,3.34-2.23,3.09-4-.21-1.48-2.09-1.93-3.57-2.1S13,301,13.11,299.55s2.05-2.17,2.34-3.6c.13-.62-.08-1.3.2-1.86.42-.84,1.63-.88,2.34-1.5,1.26-1.12.28-3.22.64-4.88.25-1.17,1.2-2.08,1.51-3.24.63-2.31-1.47-4.51-3.67-5.45a12.93,12.93,0,0,1-2.5-1.16l-.08-.06a4.53,4.53,0,0,0,1.81,2.89c1.82,1.64.85,2.35.61,4.48-.11,1,.12,1.33-.79,2-1.73,1.28-2.69.85-2.2,3.35.44,2.29-.24,1.51-2.23,2.36-1.76.76-2.92,2.65-4.35,3.84-.91.76-2.31,1.34-2.39,2.68-.17,2.55,3,2,4.51,2.6,2.47,1,1.74,4.23-.19,5.44s-5,1.76-5.17,4.68c-.13,2.25,1.14,2.74,2.88,3.49,1.39.6,1.22.78,1.21,2.43,0,3.35,1.13,4.29,4.42,3.75a8.2,8.2,0,0,1,3.18-.26c1.27.38.84.69.88,1.74.09,2.7,3.23,1.94,4.56.79,1.53-1.34,3.46-2.88,5.54-3.08a4.52,4.52,0,0,1,2.43.43,24.73,24.73,0,0,1,4,2.81,8.1,8.1,0,0,0,4.4,1.9,3.55,3.55,0,0,0,3.66-2.55,2.47,2.47,0,0,1,.2-.82,1.18,1.18,0,0,1,1.39-.35,7.08,7.08,0,0,1,1.33.77c1.64,1,3.7.75,5.58.47,1.57-.23,3.54-.92,3.54-2.5,0-1-.91-1.8-1.62-2.55s-1.29-2-.63-2.75A1.84,1.84,0,0,1,51.31,315.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,293.44l9,17.84v-8.21l.91-35,1.33,35v5.52l9.89-17.28-9.89,21.22v54.18a.57.57,0,0,1-.33.46,1.78,1.78,0,0,1-1.59,0,.58.58,0,0,1-.32-.46V315.83Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bush--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--bush--inject-11",
    d: "M24.85,370.94c2.57.41,4.88-.3,5.27-3.08a24.61,24.61,0,0,0,0-6.91c-.12-.82-.41-1.8-1.22-2a1.54,1.54,0,0,0-1.66.93,4.44,4.44,0,0,0-.28,2c-.41-.9-1-1.94-2-2a1.82,1.82,0,0,0-1.63,1.85,5.39,5.39,0,0,0,.83,2.58,2.51,2.51,0,0,0-2,.32,1.76,1.76,0,0,0-.08,2.28,5.16,5.16,0,0,0,2,1.44.91.91,0,0,0-1.22.6,1.4,1.4,0,0,0,.52,1.39A3,3,0,0,0,24.85,370.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bush--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--bush--inject-11",
    d: "M29.32,372l6.15-3.55a4.7,4.7,0,0,0,1.33-1.26,3.44,3.44,0,0,0,.75-1.59.8.8,0,0,0-.06-.61c-.22-.33-.75-.21-1,.05s-.53.5-.84.83a9.55,9.55,0,0,0,.12-2.14,1,1,0,0,0-.26-.71.81.81,0,0,0-.86,0,3.65,3.65,0,0,0-1.42,2.27,7.32,7.32,0,0,0-.09-2.72c-.21-1-1.32-1.35-1.7-.42a5.43,5.43,0,0,0-.33,1.55,6.63,6.63,0,0,0,.14,2,6.36,6.36,0,0,0-1.64-2.27c-.26-.23-.62-.46-.94-.33s-.46.67-.42,1.08a6,6,0,0,0,.84,2.48A5.11,5.11,0,0,0,27,366a.63.63,0,0,0-.66.21.85.85,0,0,0,.15.85,5.09,5.09,0,0,0,1.65,1.54,5.27,5.27,0,0,0-2-.21.69.69,0,0,0-.54.23c-.18.25,0,.6.25.81a6,6,0,0,0,1.44.86,2.22,2.22,0,0,0-.89.15.71.71,0,0,0-.42.73.88.88,0,0,0,.65.57A4.29,4.29,0,0,0,29.32,372Z",
    style: {
      fill: "#3DD064"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Building--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--building--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Wall--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "151.24 388.4 56.37 333.63 56.32 155.54 151.19 210.32 151.24 388.4",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "151.24 388.4 56.37 333.63 56.32 155.54 151.19 210.32 151.24 388.4",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "151.24 407.29 151.24 394.07 56.37 339.29 56.37 352.51 151.24 407.29",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.24 407.29 151.24 394.07 56.37 339.29 56.37 352.51 151.24 407.29",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "151.24 407.29 151.24 394.07 56.37 339.29 56.37 352.51 151.24 407.29"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--wall--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "151.24 388.4 278.83 314.74 278.79 136.65 151.19 210.32 151.24 388.4",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "151.24 388.4 278.83 314.74 278.79 136.65 151.19 210.32 151.24 388.4",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "151.24 407.29 151.24 394.07 278.83 320.4 278.83 333.63 151.24 407.29",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "151.24 407.29 151.24 394.07 278.83 320.4 278.83 333.63 151.24 407.29"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cornice--inject-11"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "151.24 390.29 53.09 333.63 53.09 339.29 151.24 395.96 151.24 390.29",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "151.24 390.29 53.09 333.63 53.09 339.29 151.24 395.96 151.24 390.29",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "282.1 314.74 282.1 320.4 151.24 395.96 151.24 390.29 282.1 314.74",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "282.1 314.74 282.1 320.4 151.24 395.96 151.24 390.29 282.1 314.74",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "278.83 312.85 278.83 314.74 151.24 388.4 54.73 332.68 53.09 333.63 151.24 390.29 282.1 314.74 278.83 312.85",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "278.83 312.85 278.83 314.74 151.24 388.4 54.73 332.68 53.09 333.63 151.24 390.29 282.1 314.74 278.83 312.85",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "151.24 390.29 151.24 388.4 56.37 333.63 56.37 331.74 53.09 333.63 151.24 390.29",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "151.24 390.29 151.24 388.4 56.37 333.63 56.37 331.74 53.09 333.63 151.24 390.29",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Door--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--door--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "256.02 288.65 256.02 327.01 232.86 340.38 232.85 302.03 256.02 288.65",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.26 323.68 256.81 327.46 232.85 341.29 232.85 333.73 250.26 323.68",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.26 323.68 256.81 327.46 232.85 341.29 232.85 333.73 250.26 323.68",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.26 323.68 232.85 333.73 232.85 302.03 250.26 291.95 250.26 323.68",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.02 327.01 256.81 327.46 256.81 288.2 256.02 288.65 256.02 327.01",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "256.02 327.01 256.81 327.46 256.81 288.2 256.02 288.65 256.02 327.01",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "256.02 327.01 256.81 327.46 256.81 288.2 256.02 288.65 256.02 327.01"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "256.81 327.46 259.9 325.67 259.9 282.85 229.76 300.25 229.76 343.07 232.85 341.29 232.85 302.03 256.81 288.2 256.81 327.46",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "256.81 327.46 259.9 325.67 259.9 282.85 229.76 300.25 229.76 343.07 232.85 341.29 232.85 302.03 256.81 288.2 256.81 327.46",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "259.9 282.85 229.76 300.25 228.99 299.8 259.13 282.4 259.9 282.85",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.85
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "259.9 282.85 229.76 300.25 228.99 299.8 259.13 282.4 259.9 282.85",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "229.76 343.07 229.76 300.25 228.99 299.8 228.99 342.63 229.76 343.07",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "228.99 299.8 228.99 342.63 229.76 343.07 229.76 300.25",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--door--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "240.02 297.89 240.02 329.6 250.26 323.68 250.26 291.98 240.02 297.89",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.42,312.62a.82.82,0,0,1,.37-.63c.2-.12.36,0,.36.21a.81.81,0,0,1-.22.51V313a.27.27,0,0,1-.12.21l0,0c-.07,0-.13,0-.13-.07v-.3C240.51,312.89,240.42,312.79,240.42,312.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.07 297.16 241.46 298.67 241.46 310.67 244.07 309.16 244.07 297.16",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.41 294.66 245.79 296.17 245.79 308.16 248.41 306.65 248.41 294.66",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.07 309.16 244.49 309.4 241.46 311.15 241.46 310.67 244.07 309.16",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.41 306.65 248.82 306.89 245.79 308.64 245.38 308.4 248.41 306.65",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.41 306.65 248.41 294.65 248.82 294.41 248.82 306.89 248.41 306.65",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.49 309.4 245.79 308.64 245.79 296.17 244.49 296.92 244.49 309.4",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.49 309.4 244.07 309.16 244.07 297.16 244.49 296.92 244.49 309.4",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "244.49 311.39 241.46 313.14 241.46 326.56 244.49 324.82 244.49 311.39"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "244.2 312.35 242.13 313.55 242.13 325.38 244.2 324.19 244.2 312.35",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.46 313.14 242.13 313.55 242.13 325.38 241.46 326.56 241.46 313.14",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.49 311.39 244.2 312.35 244.2 324.19 244.49 324.82 244.49 311.39",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.49 324.82 244.2 324.19 242.13 325.38 241.46 326.56 244.49 324.82",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "248.82 308.88 245.79 310.63 245.79 324.06 248.82 322.31 248.82 308.88"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "248.53 309.85 246.46 311.04 246.46 322.87 248.53 321.68 248.53 309.85",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.79 310.63 246.46 311.04 246.46 322.87 245.79 324.06 245.79 310.63",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.82 308.88 248.53 309.85 248.53 321.68 248.82 322.31 248.82 308.88",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.82 322.31 248.53 321.68 246.46 322.87 245.79 324.06 248.82 322.31",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "239.57 329.85 240.02 329.6 240.02 297.89 239.58 298.15 239.57 329.85",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--door--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.19,301.83l-.34.2v31.7l6.71-3.88V298.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.4,313.83a.81.81,0,0,1,.36-.64c.2-.11.36,0,.36.22a.81.81,0,0,1-.22.51v.3a.26.26,0,0,1-.12.21l0,0c-.07,0-.12,0-.12-.07v-.31C238.49,314.09,238.4,314,238.4,313.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.38 303.32 233.38 315.32 232.85 315.63 232.85 303.63 233.38 303.32",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.72 300.82 235.1 302.33 235.1 314.33 237.72 312.82 237.72 300.82",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.8 315.56 232.85 316.11 232.85 315.63 233.38 315.32 233.8 315.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.72 312.82 238.13 313.06 235.1 314.8 234.69 314.56 237.72 312.82",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.72 312.82 237.72 300.81 238.13 300.57 238.13 313.06 237.72 312.82",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.8 315.56 235.1 314.8 235.1 302.33 233.8 303.09 233.8 315.56",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.8 315.56 233.38 315.32 233.38 303.32 233.8 303.09 233.8 315.56",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "233.8 317.55 233.8 330.98 232.86 331.52 232.86 318.09 233.8 317.55"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "233.51 318.51 233.51 330.35 232.86 330.73 232.86 318.89 233.51 318.51",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.8 317.55 233.51 318.52 233.51 330.35 233.8 330.98 233.8 317.55",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.8 330.98 232.86 331.52 232.86 330.73 233.51 330.35 233.8 330.98",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "238.13 315.05 235.1 316.79 235.1 330.22 238.13 328.47 238.13 315.05"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "237.84 316.01 235.77 317.2 235.77 329.04 237.84 327.84 237.84 316.01",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.1 316.79 235.77 317.2 235.77 329.04 235.1 330.22 235.1 316.79",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.13 315.05 237.84 316.01 237.84 327.84 238.13 328.47 238.13 315.05",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.13 328.47 237.84 327.84 235.77 329.04 235.1 330.22 238.13 328.47",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "250.26 291.98 250.26 295.52 232.85 305.6 232.85 302.03 250.26 291.98"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stairs--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "234.67 342.13 234.67 347.79 233.03 348.74 233.03 360.07 251.02 370.46 251.02 366.68 247.75 364.79 247.75 361.01 244.48 359.13 244.48 355.35 241.21 353.46 241.21 349.68 237.94 347.79 237.94 344.01 234.67 342.13",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.6 327.57 233.03 341.18 237.94 344.01 261.52 330.41 256.6 327.57",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.52 334.19 237.94 347.79 241.21 349.68 264.79 336.08 261.52 334.19",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.79 339.86 241.21 353.46 244.48 355.35 268.06 341.75 264.79 339.86",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.06 345.52 244.48 359.13 247.75 361.01 271.33 347.41 268.06 345.52",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.33 351.19 247.75 364.79 251.02 366.68 274.6 353.08 271.33 351.19",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.52 330.41 237.94 344.01 237.94 347.79 261.52 334.19 261.52 330.41",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.79 336.08 241.21 349.68 241.21 353.46 264.79 339.86 264.79 336.08",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.06 341.75 244.48 355.35 244.48 359.13 268.06 345.52 268.06 341.75",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.6 353.08 251.02 366.68 251.02 370.46 274.6 356.86 274.6 353.08",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.33 347.41 247.75 361.01 247.75 364.79 271.33 351.19 271.33 347.41",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "187.77 333.31 187.77 355.72 170.87 365.47 170.87 343.07 187.77 333.31",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "187.77 333.31 187.77 355.72 170.87 365.47 170.87 343.07 187.77 333.31"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "185.49 354.2 170.87 362.64 170.87 343.07 185.49 334.63 185.49 354.2",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9500000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "185.49 354.2 170.87 362.64 170.87 343.07 185.49 334.63 185.49 354.2",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "187.77 333.31 185.49 334.63 185.49 354.2 187.77 355.72 187.77 333.31",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.76 366.69 189.88 354.5 190.93 355.1 169.8 367.3 168.76 366.69",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "168.76 366.69 189.88 354.5 190.93 355.1 169.8 367.3 168.76 366.69",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "169.8 367.3 169.8 369.74 190.93 357.54 190.93 355.1 169.8 367.3",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "169.8 367.3 169.8 369.74 190.93 357.54 190.93 355.1 169.8 367.3",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "168.76 366.69 168.76 369.13 169.8 369.74 169.8 367.3 168.76 366.69",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "168.76 366.69 168.76 369.13 169.8 369.74 169.8 367.3 168.76 366.69",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "177.72 358.69 177.72 339.11 178.95 338.41 178.95 357.98 177.72 358.69",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "217.26 316.29 217.26 338.69 200.36 348.45 200.36 326.05 217.26 316.29",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "217.26 316.29 217.26 338.69 200.36 348.45 200.36 326.05 217.26 316.29"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "214.98 337.18 200.36 345.62 200.36 326.05 214.98 317.61 214.98 337.18",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9500000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "214.98 337.18 200.36 345.62 200.36 326.05 214.98 317.61 214.98 337.18",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "217.26 316.29 214.98 317.61 214.98 337.18 217.26 338.69 217.26 316.29",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.24 349.67 219.37 337.47 220.41 338.08 199.29 350.27 198.24 349.67",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "198.24 349.67 219.37 337.47 220.41 338.08 199.29 350.27 198.24 349.67",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "199.29 350.27 199.29 352.71 220.41 340.52 220.41 338.08 199.29 350.27",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "199.29 350.27 199.29 352.71 220.41 340.52 220.41 338.08 199.29 350.27",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "198.24 349.67 198.24 352.11 199.29 352.71 199.29 350.27 198.24 349.67",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "198.24 349.67 198.24 352.11 199.29 352.71 199.29 350.27 198.24 349.67",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "207.21 341.66 207.21 322.09 208.44 321.38 208.44 340.96 207.21 341.66",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "115.25 333.63 115.25 356.03 132.16 365.79 132.16 343.38 115.25 333.63",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "115.25 333.63 115.25 356.03 132.16 365.79 132.16 343.38 115.25 333.63"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "117.53 354.52 132.16 362.96 132.16 343.38 117.53 334.94 117.53 354.52",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9500000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "117.53 354.52 132.16 362.96 132.16 343.38 117.53 334.94 117.53 354.52",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "115.25 333.63 117.53 334.94 117.53 354.52 115.25 356.03 115.25 333.63",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.27 367.01 113.14 354.81 112.1 355.41 133.22 367.61 134.27 367.01",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "134.27 367.01 113.14 354.81 112.1 355.41 133.22 367.61 134.27 367.01",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "133.22 367.61 133.22 370.05 112.1 357.85 112.1 355.41 133.22 367.61",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "133.22 367.61 133.22 370.05 112.1 357.85 112.1 355.41 133.22 367.61",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "134.27 367.01 134.27 369.45 133.22 370.05 133.22 367.61 134.27 367.01",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "134.27 367.01 134.27 369.45 133.22 370.05 133.22 367.61 134.27 367.01",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "125.3 359 125.3 339.43 124.08 338.72 124.08 358.29 125.3 359",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "75.45 310.65 75.45 333.05 92.35 342.81 92.35 320.4 75.45 310.65",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "75.45 310.65 75.45 333.05 92.35 342.81 92.35 320.4 75.45 310.65"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "77.73 331.54 92.35 339.98 92.35 320.4 77.73 311.96 77.73 331.54",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9500000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "77.73 331.54 92.35 339.98 92.35 320.4 77.73 311.96 77.73 331.54",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "75.45 310.65 77.73 311.96 77.73 331.54 75.45 333.05 75.45 310.65",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.47 344.03 73.34 331.83 72.29 332.43 93.42 344.63 94.47 344.03",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "94.47 344.03 73.34 331.83 72.29 332.43 93.42 344.63 94.47 344.03",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "93.42 344.63 93.42 347.07 72.29 334.87 72.29 332.43 93.42 344.63",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "93.42 344.63 93.42 347.07 72.29 334.87 72.29 332.43 93.42 344.63",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "94.47 344.03 94.47 346.47 93.42 347.07 93.42 344.63 94.47 344.03",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "94.47 344.03 94.47 346.47 93.42 347.07 93.42 344.63 94.47 344.03",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "85.5 336.02 85.5 316.45 84.27 315.74 84.27 335.31 85.5 336.02",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Balcony--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-11",
    style: {
      opacity: 0.15
    }
  }, _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "261.82 270.19 227.52 290 227.52 282.22 261.82 262.41 261.82 270.19"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--floor--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "227.52 282.22 261.82 262.41 270.94 267.67 236.64 287.49 227.52 282.22",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.52 282.22 227.52 283.54 236.64 288.8 236.64 287.49 227.52 282.22",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.64 287.49 270.94 267.67 270.94 268.99 236.64 288.8 236.64 287.49",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--door--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "256.1 227.35 256.1 265.71 232.93 279.09 232.92 240.74 256.1 227.35",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.26 264.49 256.88 266.16 232.92 279.99 232.93 276.8 254.26 264.49",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "254.26 264.49 256.88 266.16 232.92 279.99 232.93 276.8 254.26 264.49",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "254.26 264.49 232.93 276.8 232.92 240.74 254.26 228.41 254.26 264.49",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9500000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "254.26 264.49 232.93 276.8 232.92 240.74 254.26 228.42 254.26 264.49",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "254.26 228.42 254.26 231.98 232.92 244.3 232.92 240.74 254.26 228.42"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "245.32 233.58 244.51 234.04 244.51 272.39 245.32 271.94 245.32 233.58",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "245.32 233.58 244.51 234.04 244.51 272.39 245.32 271.94 245.32 233.58"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "244.51 234.04 244.51 272.39 243.71 271.93 243.71 234.5 244.51 234.04",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "244.51 234.04 244.51 272.39 243.71 271.93 243.71 234.5 244.51 234.04"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "256.1 265.71 256.88 266.16 256.88 226.91 256.1 227.35 256.1 265.71",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "256.1 265.71 256.88 266.16 256.88 226.91 256.1 227.35 256.1 265.71",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "256.1 265.71 256.88 266.16 256.88 226.91 256.1 227.35 256.1 265.71"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "256.88 266.16 259.97 264.38 259.97 221.55 229.83 238.95 229.83 281.77 232.92 279.99 232.92 240.74 256.88 226.91 256.88 266.16",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "256.88 266.16 259.97 264.38 259.97 221.55 229.83 238.95 229.83 281.77 232.92 279.99 232.92 240.74 256.88 226.91 256.88 266.16",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "259.97 221.55 229.83 238.95 229.06 238.51 259.2 221.11 259.97 221.55",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.85
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "259.97 221.55 229.83 238.95 229.06 238.51 259.2 221.11 259.97 221.55",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "229.83 281.77 229.83 238.95 229.06 238.51 229.06 281.33 229.83 281.77",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "229.06 238.51 229.06 281.33 229.83 281.77 229.83 238.95",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Railing--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.51,251.85a.55.55,0,0,0-.29-.48l-.27-.16h0l-8.75-5h0a.21.21,0,0,0-.2,0,.92.92,0,0,0-.33.72.38.38,0,0,0,.12.32h0l.27.16h0l7.75,4.38",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.68,253.41l-8.77-5a.11.11,0,0,0-.12,0,.36.36,0,0,0-.16.28.12.12,0,0,0,0,.11l9,5.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "269.68 255.3 260.63 250.05 260.63 261.39 269.68 266.63 269.68 255.3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--railing--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "236.46 274.47 269.68 255.3 269.68 266.63 236.46 285.8 236.46 274.47"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "236.8 274.47 227.35 268.99 227.35 280.32 236.8 285.8 236.8 274.47"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M236.65,272.49l-9-5.2a.17.17,0,0,0-.12,0,.37.37,0,0,0-.16.29c0,.05,0,.09,0,.1l9,5.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.82,263.14l16.55-9.55a.11.11,0,0,1,.11,0,.39.39,0,0,1,.17.29.1.1,0,0,1,0,.1l-16.55,9.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.07,261.54v15.57a.15.15,0,0,1-.07.1.38.38,0,0,1-.33,0,.15.15,0,0,1-.07-.1V261.54Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.61,272.49l16-9.26a.09.09,0,0,1,.11,0,.37.37,0,0,1,.17.28.12.12,0,0,1-.05.11l-16,9.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.8,251.9v15.57a.12.12,0,0,1-.07.09.33.33,0,0,1-.33,0,.12.12,0,0,1-.07-.09V251.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.86,270.9v15.57s0,.07-.07.1a.38.38,0,0,1-.33,0,.12.12,0,0,1-.06-.1V270.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.82,251.86l-32.19,18.57-8.75-4.95h0a.19.19,0,0,0-.2,0,.88.88,0,0,0-.33.71.38.38,0,0,0,.12.33h0l8.88,5a.64.64,0,0,0,.27.07.54.54,0,0,0,.28-.08l33.32-19.22a.58.58,0,0,0,.28-.49",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--balcony--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-11",
    style: {
      opacity: 0.15
    }
  }, _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "261.82 212.85 227.52 232.66 227.52 224.88 261.82 205.07 261.82 212.85"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--floor--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "227.52 224.88 261.82 205.06 270.94 210.33 236.64 230.14 227.52 224.88",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.52 224.88 227.52 226.19 236.64 231.46 236.64 230.14 227.52 224.88",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.64 230.14 270.94 210.33 270.94 211.65 236.64 231.46 236.64 230.14",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--door--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "256.1 170.01 256.1 208.37 232.93 221.75 232.92 183.39 256.1 170.01",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.26 207.14 256.88 208.82 232.92 222.65 232.93 219.46 254.26 207.14",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "254.26 207.14 256.88 208.82 232.92 222.65 232.93 219.46 254.26 207.14",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "254.26 207.14 232.93 219.46 232.92 183.39 254.26 171.07 254.26 207.14",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9500000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "254.26 207.14 232.93 219.46 232.92 183.39 254.26 171.07 254.26 207.14",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "254.26 171.07 254.26 174.64 232.92 186.96 232.92 183.39 254.26 171.07"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "245.32 176.23 244.51 176.7 244.51 215.05 245.32 214.59 245.32 176.23",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "245.32 176.23 244.51 176.7 244.51 215.05 245.32 214.59 245.32 176.23"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "244.51 176.7 244.51 215.05 243.71 214.59 243.71 177.16 244.51 176.7",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "244.51 176.7 244.51 215.05 243.71 214.59 243.71 177.16 244.51 176.7"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "256.1 208.37 256.88 208.82 256.88 169.56 256.1 170.01 256.1 208.37",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "256.1 208.37 256.88 208.82 256.88 169.56 256.1 170.01 256.1 208.37",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    points: "256.1 208.37 256.88 208.82 256.88 169.56 256.1 170.01 256.1 208.37"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "256.88 208.82 259.97 207.03 259.97 164.21 229.83 181.61 229.83 224.43 232.92 222.65 232.92 183.39 256.88 169.56 256.88 208.82",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "256.88 208.82 259.97 207.03 259.97 164.21 229.83 181.61 229.83 224.43 232.92 222.65 232.92 183.39 256.88 169.56 256.88 208.82",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "259.97 164.21 229.83 181.61 229.06 181.16 259.2 163.76 259.97 164.21",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.85
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "259.97 164.21 229.83 181.61 229.06 181.16 259.2 163.76 259.97 164.21",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "229.83 224.43 229.83 181.61 229.06 181.16 229.06 223.99 229.83 224.43",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "229.06 181.16 229.06 223.99 229.83 224.43 229.83 181.61",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--railing--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.51,194.51a.58.58,0,0,0-.28-.49l-.28-.15h0l-8.74-5h0a.22.22,0,0,0-.19,0,.89.89,0,0,0-.34.72.38.38,0,0,0,.12.32h0l.27.15h0l7.75,4.39",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.69,196.07,260.91,191a.17.17,0,0,0-.12,0,.37.37,0,0,0-.16.29.1.1,0,0,0,.05.1l9,5.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    points: "269.69 197.96 260.63 192.71 260.63 204.04 269.69 209.29 269.69 197.96"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--railing--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    points: "236.46 217.13 269.69 197.96 269.69 209.29 236.46 228.46 236.46 217.13"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    points: "236.81 217.13 227.35 211.65 227.35 222.98 236.81 228.46 236.81 217.13"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M236.65,215.15l-9-5.2s-.07,0-.12,0a.36.36,0,0,0-.16.29.11.11,0,0,0,.05.1l9,5.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.82,205.79l16.55-9.54a.11.11,0,0,1,.12,0,.36.36,0,0,1,.16.28.12.12,0,0,1,0,.11l-16.55,9.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.07,204.2v15.57a.1.1,0,0,1-.07.09.36.36,0,0,1-.32,0,.1.1,0,0,1-.07-.09V204.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.62,215.15l16-9.26a.11.11,0,0,1,.12,0,.36.36,0,0,1,.16.28.13.13,0,0,1-.05.11l-16,9.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.8,194.56v15.57s0,.06-.07.09a.36.36,0,0,1-.32,0c-.05,0-.07-.06-.07-.09V194.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.86,213.56v15.57a.11.11,0,0,1-.06.09.33.33,0,0,1-.33,0,.1.1,0,0,1-.07-.09V213.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.82,194.52l-32.19,18.57-8.74-5h0a.19.19,0,0,0-.19,0,.89.89,0,0,0-.34.72.42.42,0,0,0,.12.33h0l8.88,5a.57.57,0,0,0,.28.08.6.6,0,0,0,.28-.08L270.23,195a.58.58,0,0,0,.28-.49",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--balcony--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-11",
    style: {
      opacity: 0.15
    }
  }, _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    points: "203.62 303.65 169.33 323.46 169.33 315.69 203.62 295.87 203.62 303.65"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--floor--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "169.33 315.69 203.62 295.87 212.74 301.14 178.45 320.95 169.33 315.69",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.33 315.69 169.33 317 178.45 322.27 178.45 320.95 169.33 315.69",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.45 320.95 212.74 301.14 212.74 302.45 178.45 322.27 178.45 320.95",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--door--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "197.9 260.82 197.9 299.18 174.74 312.56 174.73 274.2 197.9 260.82",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.07 297.95 198.69 299.63 174.73 313.46 174.74 310.27 196.07 297.95",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "196.07 297.95 198.69 299.63 174.73 313.46 174.74 310.27 196.07 297.95",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "196.07 297.95 174.74 310.27 174.73 274.2 196.07 261.88 196.07 297.95",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9500000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "196.07 297.95 174.74 310.27 174.73 274.2 196.07 261.88 196.07 297.95",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    points: "196.07 261.88 196.07 265.45 174.73 277.77 174.73 274.2 196.07 261.88"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "187.13 267.04 186.32 267.51 186.32 305.86 187.13 305.4 187.13 267.04",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    points: "187.13 267.04 186.32 267.51 186.32 305.86 187.13 305.4 187.13 267.04"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "186.32 267.51 186.32 305.86 185.51 305.4 185.51 267.97 186.32 267.51",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    points: "186.32 267.51 186.32 305.86 185.51 305.4 185.51 267.97 186.32 267.51"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "197.9 299.18 198.69 299.63 198.69 260.37 197.9 260.82 197.9 299.18",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "197.9 299.18 198.69 299.63 198.69 260.37 197.9 260.82 197.9 299.18",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    points: "197.9 299.18 198.69 299.63 198.69 260.37 197.9 260.82 197.9 299.18"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "198.69 299.63 201.78 297.84 201.78 255.02 171.64 272.42 171.64 315.24 174.73 313.46 174.73 274.2 198.68 260.37 198.69 299.63",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "198.69 299.63 201.78 297.84 201.78 255.02 171.64 272.42 171.64 315.24 174.73 313.46 174.73 274.2 198.68 260.37 198.69 299.63",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "201.78 255.02 171.64 272.42 170.87 271.97 201.01 254.57 201.78 255.02",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.85
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "201.78 255.02 171.64 272.42 170.87 271.97 201.01 254.57 201.78 255.02",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "171.64 315.24 171.64 272.42 170.87 271.97 170.87 314.8 171.64 315.24",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "170.87 271.97 170.87 314.8 171.64 315.24 171.64 272.42",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--railing--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.31,285.32a.58.58,0,0,0-.28-.49l-.28-.15h0L203,279.72h0a.19.19,0,0,0-.19,0,.89.89,0,0,0-.34.71.39.39,0,0,0,.12.33h0l.27.15h0l7.75,4.39",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.49,286.88l-8.78-5.06a.17.17,0,0,0-.12,0,.37.37,0,0,0-.16.29.1.1,0,0,0,0,.1l9,5.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    points: "211.49 288.77 202.43 283.52 202.43 294.85 211.49 300.1 211.49 288.77"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--railing--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    points: "178.26 307.94 211.49 288.77 211.49 300.1 178.26 319.27 178.26 307.94"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    points: "178.61 307.94 169.15 302.46 169.15 313.79 178.61 319.27 178.61 307.94"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M178.45,306l-9-5.2a.11.11,0,0,0-.11,0,.34.34,0,0,0-.17.28.12.12,0,0,0,0,.11l9,5.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.62,296.6l16.55-9.54a.11.11,0,0,1,.12,0,.36.36,0,0,1,.16.28.12.12,0,0,1,0,.11L194.85,297Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.87,295v15.57a.1.1,0,0,1-.07.09.36.36,0,0,1-.32,0,.1.1,0,0,1-.07-.09V295Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.42,306l16-9.26a.11.11,0,0,1,.12,0,.36.36,0,0,1,.16.28.13.13,0,0,1-.05.11l-16,9.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.6,285.37v15.57s0,.06-.07.09a.36.36,0,0,1-.32,0c-.05,0-.07-.06-.07-.09V285.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.66,304.37v15.57a.11.11,0,0,1-.06.09.32.32,0,0,1-.33,0,.1.1,0,0,1-.07-.09V304.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.62,285.33,178.43,303.9,169.69,299h0a.19.19,0,0,0-.19,0,.89.89,0,0,0-.34.72.42.42,0,0,0,.12.33h0l8.88,5a.57.57,0,0,0,.28.08.6.6,0,0,0,.28-.08L212,285.81a.55.55,0,0,0,.28-.49",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--balcony--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-11",
    style: {
      opacity: 0.15
    }
  }, _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    points: "203.62 246.31 169.33 266.13 169.33 258.35 203.62 238.53 203.62 246.31"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--floor--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "169.33 258.35 203.62 238.53 212.74 243.8 178.45 263.61 169.33 258.35",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.33 258.35 169.33 259.66 178.45 264.93 178.45 263.61 169.33 258.35",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.45 263.61 212.74 243.8 212.74 245.11 178.45 264.93 178.45 263.61",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--door--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "197.9 203.48 197.9 241.84 174.74 255.21 174.73 216.86 197.9 203.48",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.07 240.61 198.68 242.28 174.73 256.11 174.74 252.93 196.07 240.61",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "196.07 240.61 198.68 242.28 174.73 256.11 174.74 252.93 196.07 240.61",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "196.07 240.61 174.74 252.93 174.73 216.86 196.07 204.54 196.07 240.61",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9500000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "196.07 240.61 174.73 252.93 174.73 216.86 196.07 204.54 196.07 240.61",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    points: "196.07 204.54 196.07 208.11 174.73 220.43 174.73 216.86 196.07 204.54"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "187.12 209.7 186.32 210.16 186.32 248.51 187.12 248.06 187.12 209.7",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    points: "187.12 209.7 186.32 210.16 186.32 248.51 187.12 248.06 187.12 209.7"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "186.32 210.16 186.32 248.51 185.51 248.05 185.51 210.63 186.32 210.16",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    points: "186.32 210.16 186.32 248.51 185.51 248.05 185.51 210.63 186.32 210.16"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "197.9 241.84 198.68 242.28 198.68 203.03 197.9 203.48 197.9 241.84",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "197.9 241.84 198.68 242.28 198.68 203.03 197.9 203.48 197.9 241.84",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    points: "197.9 241.84 198.68 242.28 198.68 203.03 197.9 203.48 197.9 241.84"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "198.68 242.28 201.77 240.5 201.77 197.68 171.64 215.07 171.64 257.9 174.73 256.11 174.73 216.86 198.68 203.03 198.68 242.28",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "198.68 242.28 201.77 240.5 201.77 197.68 171.64 215.07 171.64 257.9 174.73 256.11 174.73 216.86 198.68 203.03 198.68 242.28",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "201.77 197.68 171.64 215.07 170.87 214.63 201.01 197.23 201.77 197.68",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.85
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "201.77 197.68 171.64 215.07 170.87 214.63 201.01 197.23 201.77 197.68",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "171.64 257.9 171.64 215.07 170.87 214.63 170.87 257.45 171.64 257.9",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "170.87 214.63 170.87 257.45 171.64 257.9 171.64 215.07",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--railing--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.32,228a.56.56,0,0,0-.29-.49l-.27-.15h0l-8.75-5h0a.19.19,0,0,0-.2,0,.88.88,0,0,0-.33.71.38.38,0,0,0,.12.33h0l.27.15h0l7.75,4.38",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.49,229.53l-8.78-5.05a.11.11,0,0,0-.11,0,.36.36,0,0,0-.16.28c0,.06,0,.09,0,.11l9,5.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    points: "211.49 231.42 202.44 226.18 202.44 237.51 211.49 242.76 211.49 231.42"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--railing--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    points: "178.27 250.59 211.49 231.42 211.49 242.76 178.27 261.93 178.27 250.59"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    points: "178.61 250.59 169.16 245.12 169.16 256.45 178.61 261.93 178.61 250.59"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M178.46,248.62l-9-5.2a.11.11,0,0,0-.12,0,.36.36,0,0,0-.16.28.12.12,0,0,0,0,.11l9,5.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.63,239.26l16.55-9.54a.09.09,0,0,1,.11,0,.37.37,0,0,1,.17.28.13.13,0,0,1-.05.11l-16.55,9.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.88,237.67v15.56s0,.07-.07.1a.38.38,0,0,1-.33,0s-.07-.06-.07-.1V237.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.42,248.62l16.05-9.27a.14.14,0,0,1,.11,0,.39.39,0,0,1,.17.29.1.1,0,0,1-.05.1l-16,9.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.61,228v15.57s0,.07-.07.1a.38.38,0,0,1-.33,0s-.07-.06-.07-.1V228Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.67,247V262.6a.1.1,0,0,1-.07.09.38.38,0,0,1-.33,0,.11.11,0,0,1-.06-.09V247Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.63,228l-32.19,18.57-8.75-5h0a.24.24,0,0,0-.2,0,.92.92,0,0,0-.33.72.36.36,0,0,0,.12.32h0l8.88,5a.52.52,0,0,0,.27.07.53.53,0,0,0,.28-.07L212,228.46a.55.55,0,0,0,.28-.48",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--balcony--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-11",
    style: {
      opacity: 0.15
    }
  }, _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    points: "76.22 290.58 130.3 321.85 130.3 314.07 76.22 282.8 76.22 290.58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--floor--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "130.3 314.05 75.76 282.51 66.64 287.78 121.18 319.31 130.3 314.05",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.3 314.05 130.3 315.37 121.18 320.63 121.18 319.31 130.3 314.05",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.18 319.31 66.64 287.78 66.64 289.09 121.18 320.63 121.18 319.31",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--door--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "91.82 253.45 91.82 291.81 114.99 305.18 114.99 266.83 91.82 253.45",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.65 290.58 91.04 292.25 114.99 306.08 114.99 302.9 93.65 290.58",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "93.65 290.58 91.04 292.25 114.99 306.08 114.99 302.9 93.65 290.58",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "93.65 290.58 114.99 302.9 114.99 266.83 93.65 254.51 93.65 290.58",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9500000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "93.65 290.58 114.99 302.9 114.99 266.83 93.65 254.51 93.65 290.58",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    points: "93.65 254.51 93.65 258.08 114.99 270.4 114.99 266.83 93.65 254.51"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "102.6 259.67 103.4 260.14 103.4 298.49 102.6 298.03 102.6 259.67",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    points: "102.6 259.67 103.4 260.14 103.4 298.49 102.6 298.03 102.6 259.67"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "103.4 260.14 103.4 298.49 104.21 298.02 104.21 260.6 103.4 260.14",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    points: "103.4 260.14 103.4 298.49 104.21 298.02 104.21 260.6 103.4 260.14"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "91.82 291.81 91.04 292.25 91.04 253 91.82 253.45 91.82 291.81",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "91.82 291.81 91.04 292.25 91.04 253 91.82 253.45 91.82 291.81",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.82 291.81 91.04 292.25 91.04 253 91.82 253.45 91.82 291.81"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "91.04 292.25 87.95 290.47 87.95 247.65 118.08 265.05 118.08 307.87 114.99 306.08 114.99 266.83 91.04 253 91.04 292.25",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "91.04 292.25 87.95 290.47 87.95 247.65 118.08 265.05 118.08 307.87 114.99 306.08 114.99 266.83 91.04 253 91.04 292.25",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "87.95 247.65 118.08 265.05 118.85 264.6 88.71 247.2 87.95 247.65",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.85
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "87.95 247.65 118.08 265.05 118.85 264.6 88.71 247.2 87.95 247.65",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "118.08 307.87 118.08 265.05 118.85 264.6 118.85 307.43 118.08 307.87",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "118.85 264.6 118.85 307.43 118.08 307.87 118.08 265.05",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--railing--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67,271.93a.56.56,0,0,1,.28-.48l.27-.16h0l8.75-5h0a.21.21,0,0,1,.2,0,.89.89,0,0,1,.34.72.36.36,0,0,1-.13.32h0l-.26.15h0l-7.75,4.39",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.84,273.49l8.78-5.05a.09.09,0,0,1,.11,0,.37.37,0,0,1,.17.28.13.13,0,0,1-.05.11l-9,5.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    points: "67.84 275.38 76.9 270.13 76.9 281.46 67.84 286.71 67.84 275.38"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--railing--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    points: "121.37 306.3 67.84 275.38 67.84 286.71 121.37 317.63 121.37 306.3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    points: "121.03 306.3 130.48 300.82 130.48 312.15 121.03 317.63 121.03 306.3"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M121.18,304.32l9-5.2s.07,0,.12,0a.36.36,0,0,1,.16.29.11.11,0,0,1,0,.1l-9,5.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1,289.23,68.15,273.67s-.07,0-.11,0a.36.36,0,0,0-.16.29.11.11,0,0,0,0,.1l27,15.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.85,287.63V303.2s0,.07.07.1a.36.36,0,0,0,.32,0c.05,0,.07-.06.07-.1V287.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.22,304.32l-26-15a.11.11,0,0,0-.12,0,.36.36,0,0,0-.16.28.12.12,0,0,0,0,.11l26,15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.73,272v15.57a.11.11,0,0,0,.06.09.38.38,0,0,0,.33,0,.1.1,0,0,0,.07-.09V272Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,302.73V318.3s0,.07.07.1a.36.36,0,0,0,.32,0s.07-.06.07-.1V302.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.71,271.94l52.49,30.32,8.75-4.95h0a.19.19,0,0,1,.19,0,.89.89,0,0,1,.34.72.42.42,0,0,1-.12.33h0l-8.88,5a.53.53,0,0,1-.27.08.6.6,0,0,1-.29-.08l-53.61-31a.55.55,0,0,1-.28-.49",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--balcony--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-11",
    style: {
      opacity: 0.15
    }
  }, _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    points: "75.62 232.89 130.3 264.5 130.3 256.71 75.62 225.09 75.62 232.89"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--floor--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "130.3 256.71 75.76 225.17 66.64 230.44 121.18 261.98 130.3 256.71",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.3 256.71 130.3 258.03 121.18 263.29 121.18 261.98 130.3 256.71",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.18 261.98 66.64 230.44 66.64 231.75 121.18 263.29 121.18 261.98",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--door--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "91.82 196.11 91.82 234.47 114.99 247.85 114.99 209.5 91.82 196.11",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.65 233.24 91.04 234.92 114.99 248.75 114.99 245.56 93.65 233.24",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "93.65 233.24 91.04 234.92 114.99 248.75 114.99 245.56 93.65 233.24",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "93.65 233.24 114.99 245.56 114.99 209.5 93.65 197.18 93.65 233.24",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9500000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "93.65 233.24 114.99 245.56 114.99 209.5 93.65 197.18 93.65 233.24",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    points: "93.65 197.18 93.65 200.74 114.99 213.06 114.99 209.5 93.65 197.18"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "102.6 202.34 103.4 202.8 103.4 241.15 102.6 240.69 102.6 202.34",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    points: "102.6 202.34 103.4 202.8 103.4 241.15 102.6 240.69 102.6 202.34"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "103.4 202.8 103.4 241.15 104.21 240.69 104.21 203.26 103.4 202.8",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    points: "103.4 202.8 103.4 241.15 104.21 240.69 104.21 203.26 103.4 202.8"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "91.82 234.47 91.04 234.92 91.04 195.66 91.82 196.11 91.82 234.47",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "91.82 234.47 91.04 234.92 91.04 195.66 91.82 196.11 91.82 234.47",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.82 234.47 91.04 234.92 91.04 195.66 91.82 196.11 91.82 234.47"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "91.04 234.92 87.95 233.13 87.95 190.31 118.08 207.71 118.08 250.53 114.99 248.75 114.99 209.5 91.04 195.66 91.04 234.92",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "91.04 234.92 87.95 233.13 87.95 190.31 118.08 207.71 118.08 250.53 114.99 248.75 114.99 209.5 91.04 195.66 91.04 234.92",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "87.95 190.31 118.08 207.71 118.85 207.26 88.71 189.87 87.95 190.31",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.85
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "87.95 190.31 118.08 207.71 118.85 207.26 88.71 189.87 87.95 190.31",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "118.08 250.53 118.08 207.71 118.85 207.26 118.85 250.09 118.08 250.53",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "118.85 207.26 118.85 250.09 118.08 250.53 118.08 207.71",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--railing--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67,214.6a.58.58,0,0,1,.28-.49l.27-.15h0L76.32,209h0a.24.24,0,0,1,.2,0,.89.89,0,0,1,.34.71.37.37,0,0,1-.13.33h0l-.26.15h0l-7.75,4.39",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.84,216.16l8.78-5.06a.14.14,0,0,1,.11,0,.39.39,0,0,1,.17.29.1.1,0,0,1-.05.1l-9,5.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    points: "67.84 218.05 76.9 212.8 76.9 224.13 67.84 229.38 67.84 218.05"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--railing--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    points: "121.37 248.97 67.84 218.05 67.84 229.38 121.37 260.3 121.37 248.97"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    points: "121.03 248.97 130.48 243.49 130.48 254.82 121.03 260.3 121.03 248.97"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M121.18,247l9-5.2a.11.11,0,0,1,.12,0,.36.36,0,0,1,.16.28.12.12,0,0,1,0,.11l-9,5.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1,231.9,68.15,216.34a.09.09,0,0,0-.11,0,.36.36,0,0,0-.16.28c0,.06,0,.09,0,.11l27,15.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.85,230.3v15.57a.1.1,0,0,0,.07.09.31.31,0,0,0,.32,0,.1.1,0,0,0,.07-.09V230.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.22,247l-26-15a.11.11,0,0,0-.12,0,.36.36,0,0,0-.16.28.13.13,0,0,0,0,.11l26,15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.73,214.65v15.57a.12.12,0,0,0,.06.09.38.38,0,0,0,.33,0s.07-.06.07-.09V214.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,245.4V261a.1.1,0,0,0,.07.09.31.31,0,0,0,.32,0,.1.1,0,0,0,.07-.09V245.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.71,214.61l52.49,30.32,8.75-5h0a.19.19,0,0,1,.19,0,.89.89,0,0,1,.34.72.42.42,0,0,1-.12.33h0l-8.88,5a.52.52,0,0,1-.27.07.59.59,0,0,1-.29-.07l-53.61-31a.55.55,0,0,1-.28-.49",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Roof--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--roof--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--roof--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "281.56 136.66 183.96 80.2 53.59 155.54 151.2 211.9 281.56 136.66",
    style: {
      fill: "#3DD064"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--roof--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "281.56 136.66 183.96 80.2 53.59 155.54 151.2 211.9 281.56 136.66",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("polygon", {
    points: "183.91 85.66 183.91 89.43 268.97 138.54 272.24 136.65 183.91 85.66",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    points: "183.91 85.66 183.91 89.43 268.97 138.54 272.24 136.65 183.91 85.66"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "183.91 85.66 62.86 155.54 66.13 157.43 183.91 89.43 183.91 85.66",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.97 138.54 183.91 89.43 66.13 157.43 151.19 206.54 268.97 138.54",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    points: "268.97 138.54 183.91 89.43 66.13 157.43 151.19 206.54 268.97 138.54"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.52 144.19 67.98 157.2 83.83 166.35 106.37 153.35 90.52 144.19"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "90.67 141.26 82.49 145.98 93.94 152.59 102.12 147.87 90.67 141.26",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.49 145.98 82.49 150.7 93.94 157.31 93.94 152.59 82.49 145.98",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.12 147.87 102.12 152.59 93.94 157.31 93.94 152.59 102.12 147.87",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,144.43c-1.48.86-1.48,2.25,0,3.1a5.93,5.93,0,0,0,5.38,0c1.48-.85,1.48-2.24,0-3.1A5.93,5.93,0,0,0,88,144.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.41,145.31c-.69.37-.69,1,0,1.34a3,3,0,0,0,2.52,0c.69-.37.69-1,0-1.34A3,3,0,0,0,89.41,145.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.11,157.2a.4.4,0,0,1-.4-.4v-2.6l-1.44-.83a.41.41,0,0,1-.15-.55.4.4,0,0,1,.55-.15l1.64.94a.43.43,0,0,1,.2.35v2.84A.4.4,0,0,1,98.11,157.2Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.48,155.83a.4.4,0,0,1-.4-.4v-2.6L98.65,152a.4.4,0,1,1,.4-.7l1.64.94a.43.43,0,0,1,.2.35v2.84A.4.4,0,0,1,100.48,155.83Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.22 147.87 71.04 152.59 82.49 159.2 90.67 154.48 79.22 147.87",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.04 152.59 71.04 157.31 82.49 163.93 82.49 159.2 71.04 152.59",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.67 154.48 90.67 159.2 82.49 163.93 82.49 159.2 90.67 154.48",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.53,151c-1.48.86-1.48,2.25,0,3.1a5.93,5.93,0,0,0,5.38,0c1.48-.85,1.48-2.24,0-3.1A5.93,5.93,0,0,0,76.53,151Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,151.92c-.69.37-.69,1,0,1.34a3,3,0,0,0,2.52,0c.69-.37.69-1,0-1.34A3.08,3.08,0,0,0,78,151.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.66,163.81a.4.4,0,0,1-.41-.4v-2.6L84.82,160a.41.41,0,0,1-.15-.55.4.4,0,0,1,.55-.15l1.64.94a.43.43,0,0,1,.2.35v2.84A.4.4,0,0,1,86.66,163.81Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,162.44a.4.4,0,0,1-.4-.4v-2.6l-1.43-.83a.4.4,0,1,1,.4-.7l1.63.94a.42.42,0,0,1,.21.35V162A.4.4,0,0,1,89,162.44Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    points: "183.91 85.66 179.63 91.9 264.69 141.01 272.24 136.65 183.91 85.66"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--cornice--inject-11"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "151.2 211.9 53.59 155.54 53.59 161.31 151.19 217.67 151.2 211.9",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "151.2 211.9 53.59 155.54 53.59 161.31 151.19 217.67 151.2 211.9",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "281.56 136.66 281.56 142.43 151.19 217.67 151.2 211.9 281.56 136.66",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "281.56 136.66 281.56 142.43 151.19 217.67 151.2 211.9 281.56 136.66",
    style: {
      fill: "#fff"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Boxes--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--boxes--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--back-box--inject-11"
  }, _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    points: "47.51 413.55 89.86 389.1 143.12 419.84 100.76 444.3 47.51 413.55"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "89.86 389.1 89.86 347.28 46.65 372.23 82.8 393.17 89.86 389.1",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.86 347.28 89.86 389.1 107.82 399.46 143.97 378.52 89.86 347.28",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--front-box--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "46.65 372.23 46.65 413.06 100.76 444.3 100.76 403.54 46.65 372.23",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.76 403.54 100.76 444.3 143.97 419.35 143.97 378.52 100.76 403.54",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.76 403.54 101.61 442.74 133 425.69 100.76 444.3 100.76 403.54",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.93,431.19a.89.89,0,0,1-.45-.12,1.35,1.35,0,0,1-.55-1.23v-3.61h0V426l.19,0,2.83-1.66v4a3.27,3.27,0,0,1-1.4,2.63A1.27,1.27,0,0,1,105.93,431.19Zm-.55-4.69v3.34a.94.94,0,0,0,.33.84.68.68,0,0,0,.62-.07,2.86,2.86,0,0,0,1.16-2.24v-.3h-1l-.2-1.42Zm1.46,1.12h.65v-2.5l-1.69,1,.84.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.44,434.07a.23.23,0,0,1-.23-.23v-3a.22.22,0,0,1,.23-.22.23.23,0,0,1,.23.22v3A.24.24,0,0,1,106.44,434.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.12,434.83a.23.23,0,0,1-.11-.43l2.63-1.52a.23.23,0,0,1,.31.08.22.22,0,0,1-.08.31l-2.64,1.53A.2.2,0,0,1,105.12,434.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.51,429.6a.5.5,0,0,1-.24-.06A.6.6,0,0,1,114,429v-.62a.23.23,0,0,1,.23-.23.23.23,0,0,1,.23.23V429c0,.1,0,.14,0,.15s.07,0,.15,0a1.34,1.34,0,0,0,.42-1v-4a.23.23,0,0,1,.23-.23.23.23,0,0,1,.23.23v4a1.74,1.74,0,0,1-.65,1.42A.7.7,0,0,1,114.51,429.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.12,426.08v-.4a6.44,6.44,0,0,1,2.91-5,1.92,1.92,0,0,1,3.13,1.81v.13Zm4.27-5.39a2.37,2.37,0,0,0-1.14.35,6,6,0,0,0-2.65,4.24l5.1-2.95a1.66,1.66,0,0,0-.7-1.48A1.16,1.16,0,0,0,116.39,420.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.67,425a.22.22,0,0,1-.23-.22V417a.23.23,0,1,1,.45,0v7.73A.22.22,0,0,1,122.67,425Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,418.76a.15.15,0,0,1-.09,0,.23.23,0,0,1-.11-.3l.8-1.86.91,1a.22.22,0,0,1,0,.32.23.23,0,0,1-.32,0l-.43-.5-.52,1.21A.22.22,0,0,1,122,418.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.77,423.76a.23.23,0,0,1-.23-.23V415.8a.22.22,0,0,1,.23-.22.23.23,0,0,1,.23.22v7.73A.24.24,0,0,1,124.77,423.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.1,417.56H124a.23.23,0,0,1-.11-.3l.8-1.87.9,1a.22.22,0,0,1,0,.32.23.23,0,0,1-.32,0l-.43-.5-.52,1.21A.22.22,0,0,1,124.1,417.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.91,401.21,67.7,408a1.18,1.18,0,0,1,.54.93v8.2c0,.67-.48,1-1.07.61L55.38,411a1.18,1.18,0,0,1-.54-.92v-8.21C54.84,401.15,55.32,400.87,55.91,401.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.61 402.49 56.02 402.72 56.02 409.96 55.61 409.73 55.61 402.49",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.25 403.43 57.94 403.84 57.94 411.07 57.25 410.67 57.25 403.43",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.88 404.37 59.28 404.61 59.28 411.84 58.88 411.61 58.88 404.37",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.11 405.07 60.92 405.55 60.92 412.79 60.11 412.31 60.11 405.07",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.15 406.26 62.55 406.49 62.55 413.73 62.15 413.5 62.15 406.26",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.33 406.92 64.18 407.43 64.18 414.67 63.33 414.16 63.33 406.92",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.42 408.14 65.82 408.38 65.82 415.61 65.42 415.38 65.42 408.14",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.35 408.67 66.55 408.79 66.55 416.03 66.35 415.91 66.35 408.67",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.67 407.75 64.87 407.87 64.87 415.1 64.67 414.99 64.67 407.75",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.38 405.82 61.58 405.94 61.58 413.18 61.38 413.06 61.38 405.82",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.58 404.79 59.78 404.9 59.78 412.14 59.58 412.02 59.58 404.79",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.28 404.07 58.48 404.19 58.48 411.43 58.28 411.31 58.28 404.07",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.53 403.01 56.73 403.12 56.73 410.36 56.53 410.25 56.53 403.01",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.05 409.09 67.45 409.32 67.45 416.56 67.05 416.32 67.05 409.09",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "89.86 347.28 46.65 372.23 100.76 403.54 143.97 378.52 89.86 347.28",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.65 372.23 100.76 401.99 143.97 378.52 100.76 403.54 46.65 372.23",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.58 361.87 118.73 393.14 125.38 389.29 71.24 358.03 64.58 361.87",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.38 389.28 125.38 397.74 124.58 397.29 123.74 398.73 122.91 398.24 122.07 399.7 121.23 399.2 120.4 400.65 119.56 400.17 118.72 401.61 118.72 393.14 125.38 389.28",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.38 389.28 125.38 397.74 124.58 397.29 123.74 398.73 122.91 398.24 122.07 399.7 121.23 399.2 120.4 400.65 119.56 400.17 118.72 401.61 118.72 393.14 125.38 389.28",
    style: {
      opacity: 0.25
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "102.62 356.33 64.93 378.09 102.62 399.92 140.31 378.09 102.62 356.33",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--back-box--inject-11"
  }, _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    points: "72.1 379.15 103.6 360.97 135.1 379.15 103.6 397.34 72.1 379.15"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "103.6 360.97 103.6 324.98 71.36 343.6 102.48 361.62 103.6 360.97",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.6 324.98 103.6 360.97 104.73 361.62 135.84 343.6 103.6 324.98",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--front-box--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "71.36 343.6 71.36 378.73 103.6 397.34 103.6 362.27 71.36 343.6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.6 362.27 103.6 397.34 135.84 378.73 135.84 343.6 103.6 362.27",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.6 362.27 104.34 396 131.34 381.32 103.6 397.34 103.6 362.27",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108.05,386.06a.8.8,0,0,1-.38-.1,1.16,1.16,0,0,1-.48-1.06v-3.1h0v-.23l.16,0,2.44-1.43v3.47a2.83,2.83,0,0,1-1.2,2.27A1.18,1.18,0,0,1,108.05,386.06Zm-.47-4v2.87a.8.8,0,0,0,.28.72.55.55,0,0,0,.53-.06,2.44,2.44,0,0,0,1-1.93v-.25h-.91l-.17-1.22Zm1.25,1h.57v-2.14l-1.46.85.72.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.49,388.54a.2.2,0,0,1-.2-.2v-2.61a.2.2,0,0,1,.2-.2.19.19,0,0,1,.19.2v2.61A.19.19,0,0,1,108.49,388.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.35,389.19a.2.2,0,0,1-.17-.1.19.19,0,0,1,.08-.26l2.27-1.31a.18.18,0,0,1,.26.07.18.18,0,0,1-.07.26l-2.27,1.31A.17.17,0,0,1,107.35,389.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.44,384.69a.42.42,0,0,1-.22-.05.54.54,0,0,1-.23-.47v-.54a.2.2,0,0,1,.2-.19.2.2,0,0,1,.19.19v.54c0,.08,0,.12,0,.13s.06,0,.13,0a1.16,1.16,0,0,0,.36-.89v-3.47a.19.19,0,0,1,.19-.19.19.19,0,0,1,.2.19v3.47a1.49,1.49,0,0,1-.55,1.22A.64.64,0,0,1,115.44,384.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.38,381.66v-.34a5.54,5.54,0,0,1,2.5-4.33,1.9,1.9,0,0,1,1.89-.17,1.87,1.87,0,0,1,.8,1.73v.11Zm3.67-4.63a2,2,0,0,0-1,.3,5.15,5.15,0,0,0-2.28,3.64l4.39-2.53a1.43,1.43,0,0,0-.6-1.28A1.07,1.07,0,0,0,117.05,377Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.45,380.69a.19.19,0,0,1-.19-.19v-6.65a.2.2,0,1,1,.39,0v6.65A.19.19,0,0,1,122.45,380.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.88,375.37l-.07,0a.2.2,0,0,1-.11-.26l.7-1.6.77.89a.19.19,0,0,1,0,.28.2.2,0,0,1-.28,0l-.37-.43-.45,1A.2.2,0,0,1,121.88,375.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.26,379.66a.18.18,0,0,1-.19-.19v-6.65a.19.19,0,0,1,.19-.2.2.2,0,0,1,.2.2v6.65A.19.19,0,0,1,124.26,379.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.69,374.34l-.08,0a.2.2,0,0,1-.1-.26l.7-1.6.77.89a.2.2,0,0,1,0,.28.19.19,0,0,1-.27,0l-.37-.43-.45,1A.21.21,0,0,1,123.69,374.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.33,368.54l10.15,5.86a1,1,0,0,1,.46.79v7.06c0,.58-.41.82-.91.53l-10.15-5.87a1,1,0,0,1-.46-.79v-7.06C78.42,368.48,78.83,368.24,79.33,368.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.08 369.63 79.42 369.83 79.42 376.06 79.08 375.86 79.08 369.63",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.49 370.44 81.08 370.8 81.08 377.02 80.49 376.67 80.49 370.44",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.89 371.26 82.24 371.46 82.24 377.68 81.89 377.48 81.89 371.26",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.95 371.86 83.64 372.27 83.64 378.5 82.95 378.08 82.95 371.86",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.7 372.88 85.05 373.08 85.05 379.31 84.7 379.11 84.7 372.88",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.72 373.45 86.45 373.89 86.45 380.12 85.72 379.68 85.72 373.45",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.52 374.5 87.86 374.7 87.86 380.93 87.52 380.73 87.52 374.5",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.32 374.96 88.49 375.06 88.49 381.29 88.32 381.19 88.32 374.96",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.87 374.16 87.05 374.26 87.05 380.49 86.87 380.39 86.87 374.16",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.04 372.5 84.22 372.6 84.22 378.83 84.04 378.73 84.04 372.5",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.49 371.61 82.66 371.71 82.66 377.94 82.49 377.84 82.49 371.61",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.38 371 81.55 371.1 81.55 377.33 81.38 377.23 81.38 371",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.87 370.08 80.04 370.18 80.04 376.41 79.87 376.31 79.87 370.08",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.92 375.31 89.27 375.51 89.27 381.74 88.92 381.54 88.92 375.31",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "103.6 324.98 71.36 343.6 103.6 362.27 135.84 343.6 103.6 324.98",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.36 343.6 103.6 360.94 135.84 343.6 103.6 362.27 71.36 343.6",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.69 335.32 117.96 353.95 123.69 350.64 91.42 332.01 85.69 335.32",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.69 350.64 123.69 357.92 123 357.52 122.28 358.76 121.56 358.34 120.84 359.6 120.12 359.17 119.4 360.42 118.68 360.01 117.96 361.25 117.96 353.95 123.69 350.64",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.69 350.64 123.69 357.92 123 357.52 122.28 358.76 121.56 358.34 120.84 359.6 120.12 359.17 119.4 360.42 118.68 360.01 117.96 361.25 117.96 353.95 123.69 350.64",
    style: {
      opacity: 0.25
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Locator--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pin--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.54,92.2V87.86a55,55,0,0,1,2.81-16.69v0c4.56-14.11,14.14-27.57,25.23-34C171.64,33.1,178.09,32.59,183,35l-9.71-5.59a14.33,14.33,0,0,0-8.07-2.36c-.45,0-.9,0-1.36.06a14.08,14.08,0,0,0-1.42.17,12.14,12.14,0,0,0-1.44.27c-.48.1-1,.24-1.47.39a24.67,24.67,0,0,0-3.05,1.13c-.51.22-1,.48-1.56.73s-1.06.56-1.58.86c-15.48,8.94-28,31.63-28,50.68v4.35c0,19,25.62,39.76,25.62,39.76l10.39,5.86a3.79,3.79,0,0,1-.53-.39C153.16,123.9,136.54,106.87,136.54,92.2Zm30.6-40.06a11.2,11.2,0,0,1,.18,1.46c0,.16,0,.33,0,.51a8.33,8.33,0,0,1,0,.87c0,8.93-6.27,19.81-14,24.27-.29.17-.56.32-.84.45s-.56.27-.83.39l-.81.33-.08,0c1.2,6.84,6.9,9.23,13.78,5.28,7.74-4.48,14-15.35,14-24.29C178.59,53.52,173.66,49.77,167.14,52.14Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.54,92.2V87.86a55,55,0,0,1,2.81-16.69v0c4.56-14.11,14.14-27.57,25.23-34C171.64,33.1,178.09,32.59,183,35l-9.71-5.59a14.33,14.33,0,0,0-8.07-2.36c-.45,0-.9,0-1.36.06a14.08,14.08,0,0,0-1.42.17,12.14,12.14,0,0,0-1.44.27c-.48.1-1,.24-1.47.39a24.67,24.67,0,0,0-3.05,1.13c-.51.22-1,.48-1.56.73s-1.06.56-1.58.86c-15.48,8.94-28,31.63-28,50.68v4.35c0,19,25.62,39.76,25.62,39.76l10.39,5.86a3.79,3.79,0,0,1-.53-.39C153.16,123.9,136.54,106.87,136.54,92.2Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.14,52.14a11.2,11.2,0,0,1,.18,1.46c0,.16,0,.33,0,.51a8.33,8.33,0,0,1,0,.87c0,8.93-6.27,19.81-14,24.27-.29.17-.56.32-.84.45s-.56.27-.83.39l-.81.33-.08,0c1.2,6.84,6.9,9.23,13.78,5.28,7.74-4.48,14-15.35,14-24.29C178.59,53.52,173.66,49.77,167.14,52.14Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.61,55.49c0-19.05-12.55-27.26-28-18.32s-28,31.63-28,50.69V92.2c0,14.67,16.63,31.7,24.27,38.75a3.77,3.77,0,0,0,6-1.11c6.6-13.51,25.84-54.23,25.84-70Zm-28,30.23c-7.74,4.47-14,.85-14-8.09s6.28-19.81,14-24.27,14-.85,14,8.09S172.32,81.25,164.58,85.72Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,35l-9.71-5.59a14.33,14.33,0,0,0-8.07-2.36c-.45,0-.9,0-1.36.06a14.08,14.08,0,0,0-1.42.17,12.14,12.14,0,0,0-1.44.27c-.48.1-1,.24-1.47.39a24.67,24.67,0,0,0-3.05,1.13c-.51.22-1,.48-1.56.73s-1.06.56-1.58.86c-10.47,6-19.59,18.38-24.4,31.63l11.21,6.47c4.81-13.24,13.94-25.58,24.41-31.63C171.65,33.1,178.09,32.59,183,35Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,35l-9.71-5.59a14.33,14.33,0,0,0-8.07-2.36c-.45,0-.9,0-1.36.06a14.08,14.08,0,0,0-1.42.17,12.14,12.14,0,0,0-1.44.27c-.48.1-1,.24-1.47.39a24.67,24.67,0,0,0-3.05,1.13c-.51.22-1,.48-1.56.73s-1.06.56-1.58.86c-10.47,6-19.59,18.38-24.4,31.63l11.21,6.47c4.81-13.24,13.94-25.58,24.41-31.63C171.65,33.1,178.09,32.59,183,35Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.59,37.17l-1.66,1.15a16.88,16.88,0,0,0-1.64,1.17c-1,.86-2.12,1.63-3.07,2.59a39.89,39.89,0,0,0-2.87,2.8L154,46.34l-1.28,1.54a73.35,73.35,0,0,0-14.35,28.38c-.36,1.29-.56,2.61-.85,3.92s-.36,2.65-.55,4-.19,2.67-.26,4l-.12,4-.12-4c0-1.34,0-2.69.05-4s.24-2.7.44-4,.41-2.68.72-4a66.32,66.32,0,0,1,14.51-28.68A46.26,46.26,0,0,1,164.59,37.17Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.59,37.17l-1.66,1.15a16.88,16.88,0,0,0-1.64,1.17c-1,.86-2.12,1.63-3.07,2.59a39.89,39.89,0,0,0-2.87,2.8L154,46.34l-1.28,1.54a73.35,73.35,0,0,0-14.35,28.38c-.36,1.29-.56,2.61-.85,3.92s-.36,2.65-.55,4-.19,2.67-.26,4l-.12,4-.12-4c0-1.34,0-2.69.05-4s.24-2.7.44-4,.41-2.68.72-4a66.32,66.32,0,0,1,14.51-28.68A46.26,46.26,0,0,1,164.59,37.17Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Map--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--map--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.3,414.49l20.3-5.85,21-17.75a1.89,1.89,0,0,1,2-.18l50.28,29a.82.82,0,0,1,.12,1.43l-21,17.75-20.3,5.86-22,18.55-22.49,7.42a3.14,3.14,0,0,1-2.27-.23l-2.3-1.33-48-27.69c-.59-.35-.55-.8.11-1l22.49-7.42Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.3,414.49l20.3-5.85,21-17.75a1.89,1.89,0,0,1,2-.18l50.28,29a.82.82,0,0,1,.12,1.43l-21,17.75-20.3,5.86-22,18.55-22.49,7.42a3.14,3.14,0,0,1-2.27-.23l-2.3-1.33-48-27.69c-.59-.35-.55-.8.11-1l22.49-7.42Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "205.6 408.64 258.04 438.91 237.74 444.77 185.3 414.5 205.6 408.64",
    style: {
      fill: "#3DD064"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.75,463.32l-22.49,7.42a3.14,3.14,0,0,1-2.27-.23l-50.28-29c-.59-.35-.55-.8.11-1l22.49-7.42Z",
    style: {
      fill: "#3DD064"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "208.98 410.59 228.23 394.35 273.89 420.72 254.65 436.96 208.98 410.59",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.68 416.45 234.35 442.81 254.65 436.96 208.98 410.59 188.68 416.45",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      mixBlendMode: "multiply"
    }
  }, _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    points: "188.68 416.45 234.35 442.81 254.65 436.96 208.98 410.59 188.68 416.45"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "166.7 435 212.37 461.37 234.35 442.81 188.68 416.45 166.7 435",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.32 441.39 192.99 467.76 212.37 461.37 166.7 435 147.32 441.39",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      mixBlendMode: "multiply"
    }
  }, _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    points: "147.32 441.39 192.99 467.76 212.37 461.37 166.7 435 147.32 441.39"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "262.76 430.12 256.35 426.21 266.49 416.45 273.89 420.72 262.76 430.12",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.65 425.24 264.8 415.47 249.58 406.65 239.43 416.45 254.65 425.24",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.89 405.7 237.74 415.47 232.66 412.54 234.36 397.89 247.89 405.7",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.97 411.56 232.66 396.92 228.23 394.35 211.73 408.27 230.97 411.56",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.73 433.54 253.81 428.65 260.15 432.32 254.65 436.96 248.73 433.54",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.12 427.68 247.04 432.56 231.84 423.78 236.9 418.89 252.12 427.68",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.13 422.8 235.2 417.91 230.56 415.23 220.82 413.52 220.82 417.42 230.13 422.8",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.13 416.45 219.13 413.22 211.09 411.81 219.13 416.45",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.67,419.38a8.78,8.78,0,0,1,5.93.49c1.4.8,1,1.9-.85,2.44a8.74,8.74,0,0,1-5.92-.49C208.43,421,208.81,419.92,210.67,419.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.17,418.32a5.63,5.63,0,0,1,1.05.46,2.44,2.44,0,0,1,1.46,2.4,2.13,2.13,0,0,1-.24.73l4.08,2.35,7.61-1.46-9.3-5.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.13 416.45 213.92 417.35 211.24 417.72 202.22 412.54 208.98 410.59 219.13 416.45",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.69,416.45l12.7,7.33,7.56-1a2.31,2.31,0,0,1-1.2-2.23,1.9,1.9,0,0,1,.23-.73l-10.27-5.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.92,424.66l6.06,3.5,10.18-2-4.24-2.43,0,0h0a11.09,11.09,0,0,1-1.43.09,10.05,10.05,0,0,1-2.89-.39h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.83 423.78 247.04 432.56 239.43 434.03 224.22 425.24 231.83 423.78",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.98 428.17 219.15 426.21 234.36 435 224.21 436.96 208.98 428.17",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.73 433.54 254.65 436.96 247.89 438.91 241.12 435 248.73 433.54",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.9 437.93 236.05 435.98 243.38 440.21 234.35 442.81 225.9 437.93",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.84 428.17 193.18 438.57 178.54 430.12 192.07 424.26 198.84 428.17",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.9 437.93 224.21 440.86 224.74 450.93 234.35 442.81 225.9 437.93",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.21 436.96 222.51 439.89 201.3 427.64 202.91 424.66 224.21 436.96",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.39 423.78 199.68 426.7 185.94 418.77 188.68 416.45 201.39 423.78",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.53 429.14 221.67 441.35 222.21 453.06 220.61 454.41 194.86 439.54 200.53 429.14",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.38 423.28 184.56 419.93 174.94 428.05 176.84 429.14 190.38 423.28",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.86 456.73 210.68 452.58 207.29 458.44 212.37 461.37 217.86 456.73",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.53,
    y: 448.67,
    width: 6.77,
    height: 7.81,
    transform: "translate(-289.99 402.88) rotate(-60)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.53 446.72 193.24 442.51 190 448.46 197.14 452.58 200.53 446.72",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.34 447.5 191.57 441.55 176.84 433.05 169.45 432.68 166.7 435 188.34 447.5",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.57 429.2 176.84 431.1 171.57 430.89 173.57 429.2",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.12,450.69a8.74,8.74,0,0,1,5.92.49c1.4.81,1,1.9-.84,2.44a8.74,8.74,0,0,1-5.92-.49C177.88,452.32,178.25,451.23,180.12,450.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.29 458.44 200.53 460.39 205.91 463.5 212.37 461.37 207.29 458.44",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.6 457.46 198.83 459.42 192.07 455.51 198.84 453.56 205.6 457.46",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.14,452.58l-6.76,1.95-2.26-1.3s1.07-2.39-2.09-3.39l4-1.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.34,447.5l-4.17,1.5a13.83,13.83,0,0,0-3.38,0l-12.4-7.16,6.76-1.95Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.46 438.91 166.7 440.86 160.24 437.13 166.7 435 173.46 438.91",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.93 438.55 166.7 444.77 158.24 447.7 147.32 441.39 155.93 438.55",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.39,445.75l8.89,5.13a2.44,2.44,0,0,0,.31,3l-5.82,1.6-11.84-6.84,8.25-2.81",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.46,456.49l6-1.52a8.63,8.63,0,0,0,5.33.25l9,5.17,1.69,6.56-2.46.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.45 461.37 196.87 466.48 201.6 464.92 195.45 461.37",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chartacter--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382,338.21l1.29-12-13.76.91s.21,6.52.4,10.22c.11,2.18-2.83,6.23-2.83,6.23s6.46,3.47,9.93,2.26,5.29-5.53,5.24-6.46S382,338.21,382,338.21Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.83,357a3,3,0,0,0,.58,3.2c1.35,1.12,5.31,3,10.6,2.44s8.17-2,10.31-3.64,5.14-3.9,7.54-4.35a15,15,0,0,0,5.37-1.95c.72-.63.66-3.49.66-3.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,338.19a.85.85,0,0,1,.79.68c.15.79.28,3.08.61,4.38a21.58,21.58,0,0,1,.41,6.93c-.31,1.46-3.95,2.41-6.27,3.2a29.9,29.9,0,0,0-7.56,4.29,21.94,21.94,0,0,1-11.2,3.7c-4.07-.1-8.64-1.41-9.66-3.2-1.26-2.2-2.17-4.76,3.91-7.27,1.15-.48,5.2-2.63,6.58-3.42,3.74-2.11,6.37-4.07,8.14-7.9a2.16,2.16,0,0,1,.89-1.16,2,2,0,0,1,1.17-.08,43,43,0,0,1,5.92,1.16c.8.38,1.94.82,1.91,1.79a3.13,3.13,0,0,1-.24,1c-.08.2-.14.46,0,.58s.41,0,.57-.14a14.88,14.88,0,0,0,1.66-1.8,5.13,5.13,0,0,1,1-.89c.33-.24.75-.35,1-.61S381.94,338.65,382,338.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,357.67c1.07-.79,2.2-1.56,3.33-2.24h0s-7.16,3.91-10,2c-1.83-1.21-.93-2.63-.88-3.09s-6.42-3.8-8.21-4h0c-.5.25-.92.45-1.19.56-6.08,2.51-5.17,5.07-3.91,7.27,1,1.79,4.32,3.22,9.58,3.31C362.11,361.54,367.44,359.55,370,357.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.92,353c-3.78,1.34-2.18,2-1.14,2.18s7.43-3.18,11.33-6c4.06-2.9,6.65-6.11,8.16-7.18.56-.4,1.17-.89,1.71-1.35-.08-.77-.15-1.48-.22-1.85a.85.85,0,0,0-.79-.68c0,.46,0,.88-.32,1.22s-.71.37-1,.61a5.13,5.13,0,0,0-1,.89,14.88,14.88,0,0,1-1.66,1.8C374.64,346.55,366.7,351.7,362.92,353Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.06,354.71a.42.42,0,0,0,.24-.07.34.34,0,0,0,.06-.49c-1-1.23-6-4.2-8.78-4a.35.35,0,1,0,.06.69c2.59-.21,7.31,2.72,8.13,3.7A.37.37,0,0,0,362.06,354.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.36,352.88a.34.34,0,0,0,.24-.07.33.33,0,0,0,.06-.49c-1-1.23-6-4.19-8.78-4a.36.36,0,0,0-.33.38.35.35,0,0,0,.4.31c2.58-.21,7.3,2.73,8.13,3.7A.35.35,0,0,0,365.36,352.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.67,351.15a.33.33,0,0,0,.23-.07.33.33,0,0,0,.06-.49c-1-1.23-6-4.2-8.78-4a.35.35,0,1,0,.07.69c2.59-.21,7.31,2.73,8.13,3.7A.36.36,0,0,0,368.67,351.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.74,349.17a.4.4,0,0,0,.23-.08.33.33,0,0,0,.06-.49c-1-1.23-6-4.19-8.78-4a.36.36,0,0,0-.33.38.36.36,0,0,0,.4.32c2.58-.22,7.31,2.72,8.13,3.69A.4.4,0,0,0,371.74,349.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.74,347.18a.39.39,0,0,0,.23-.07.33.33,0,0,0,.07-.49c-1.43-1.75-6.65-4.24-9.41-4a.36.36,0,0,0-.34.38.38.38,0,0,0,.41.32c2.49-.21,7.48,2.18,8.75,3.73A.37.37,0,0,0,374.74,347.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.17,344.77,406,333.38l14-2.17.63,11s1.49,3.94.64,5.39-10.17,3.09-11,2.14S409.17,344.77,409.17,344.77Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.61,369.6c.46,3.53,1.23,5.8,2.78,7.7s4.28,2.18,7,1.2,6.07-3.1,6.65-6.27a17.27,17.27,0,0,0-.53-8.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.66,342.23c1.13-.07.91,4.78,1.85,9.47,1,5,2.88,6.92,3.76,11.05,1,4.7.86,6.89-.86,10.05s-8.25,6.94-11.82,3.23c-2.91-3-3.26-6.77-3.31-11.61a109.86,109.86,0,0,0-.52-12.24c-.45-3.57-1.53-6.74-.58-7.27.11.52.22,1.18.33,1.69s.32,2.32.95,2.25a6.79,6.79,0,0,0-.07-1.35,1.53,1.53,0,0,1,.23-1.21,5.24,5.24,0,0,1,1.8-.94c1.09-.35,3-.78,4.16-1,.55-.12,1.11-.22,1.67-.29a4.58,4.58,0,0,1,1.43,0,.87.87,0,0,1,.64.4,1.43,1.43,0,0,1,.09.54,3.17,3.17,0,0,0,.21,1c0,.14.17.29.32.24a.31.31,0,0,0,.17-.32c0-.58-.14-1-.22-1.66,0-.31-.11-.72-.14-1S420.71,342.54,420.66,342.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.93,361.41c.15.68,1.1,5.18-.25,6.2s-2.54-2.39-2.54-2.39-3.63-.48-8.71,2.25c.32.71-.33,3.27-1.79,2.95s-2.35-5.51-2.36-5.58c.08,4.63.48,8.25,3.31,11.19,3.57,3.71,10.11-.06,11.82-3.23s1.87-5.35.86-10.05C426.17,362.27,426.05,361.83,425.93,361.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.76,365.58c.13,1.74,2,.89,1.95-1.58s-1.95-8.08-2.2-12.3c-.4-5.79-.72-9.54-1.85-9.47,0,.06,0,.12,0,.18l.3,2.41c0,.35.11.66.13,1,.25,3.54.39,10.42.94,13.62A51.11,51.11,0,0,1,422.76,365.58Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415,367.34a49.69,49.69,0,0,1-1.45-5.95c-.59-3.16-2.57-9.47-3.55-12.87a7.64,7.64,0,0,1-.52-1.92c-.1-.48-.21-1.08-.31-1.58l0-.11c-.68.4-.41,3.14,0,4.56s.85,2.93,1.33,5c1.22,4,1.42,10,2.2,12.34S415.51,369,415,367.34Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.33,367.62l.15-.06a15.48,15.48,0,0,1,8.58-2,.46.46,0,0,0,.49-.33.34.34,0,0,0-.32-.41,16.19,16.19,0,0,0-9.18,2.11.37.37,0,0,0-.14.52A.39.39,0,0,0,414.33,367.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.16,364l.13-.05a19.1,19.1,0,0,1,9.61-2.21.45.45,0,0,0,.48-.34.34.34,0,0,0-.34-.4,19.69,19.69,0,0,0-10.15,2.33.37.37,0,0,0-.16.52A.4.4,0,0,0,413.16,364Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.41,358.18a.46.46,0,0,0,.33-.3.34.34,0,0,0-.29-.43c-5.12-.82-9.94,2.12-10.14,2.25a.36.36,0,0,0-.14.52.45.45,0,0,0,.57.08s4.73-2.89,9.49-2.11A.55.55,0,0,0,422.41,358.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.9,354.84a.44.44,0,0,0,.34-.29.34.34,0,0,0-.28-.44,14.93,14.93,0,0,0-10.35,2.25.37.37,0,0,0-.11.53.45.45,0,0,0,.58,0,14.23,14.23,0,0,1,9.64-2.08A.53.53,0,0,0,421.9,354.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.33,351.09a.45.45,0,0,0,.33-.28.34.34,0,0,0-.27-.44c-5.29-1-10.22,2.22-10.42,2.36a.36.36,0,0,0-.12.52.42.42,0,0,0,.57.06c.05,0,4.81-3.15,9.72-2.21A.41.41,0,0,0,421.33,351.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.1,224.51c2.63,27.92,3.85,66.2,3.85,66.2.22,2.12,1.75,5.73,2.93,16.19,1.25,11,1.29,26.63,1.29,26.63s-7.35,4.27-13.49,2.29c0,0-6.1-24.44-9.46-37.4-3.17-12.28-7.65-31-7.65-31L386.26,286s.55,8,.42,13.55c-.15,6.49-3.78,31.37-3.78,31.37s-7.24,4.87-13.66,0c0,0-1.91-36.37-2.23-44.17-.61-15.3-.5-45-.3-64.77Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.1,224.51c2.63,27.92,3.85,66.2,3.85,66.2.22,2.12,1.75,5.73,2.93,16.19,1.25,11,1.29,26.63,1.29,26.63s-7.35,4.27-13.49,2.29c0,0-6.1-24.44-9.46-37.4-3.17-12.28-7.65-31-7.65-31L386.26,286s.55,8,.42,13.55c-.15,6.49-3.78,31.37-3.78,31.37s-7.24,4.87-13.66,0c0,0-1.91-36.37-2.23-44.17-.61-15.3-.5-45-.3-64.77Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.57,267.44l-3.49-19.84s-7.41-1-11.26-4.39c0,0,2.52,4.57,9.53,6.25l3.44,18.06L386.26,286Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.34,333.84c-1.5,2.11-8.26,4.31-13.75,2.5l-1-4.28c4.15,1.26,11.3-.13,14.62-2.9Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.94,331.62c-1.83,1.81-8.69,2.8-13.8.05l-.28-4.4c3.87,2,10.94,2,14.68-.17Z",
    style: {
      fill: "#3DD064"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.63,206.43c2.63-.17,16.57-1.62,16.57-1.62l3.64,12.06c-7.52-.42-14,.08-20.95,0a32,32,0,0,0-5.89.49c-1.47.24-4.8,1.05-6.27,1.13-7.33.39-8.72-.18-11.77-3.64a1.88,1.88,0,0,1-1.16-2.29c-1-1.17.1-2.43,2-2.69s5.29-.69,7.92-1.17c1.3-.2,2.36-.69.38-1.12s-4.76-.87-4.37-3.47a.43.43,0,0,1,.45-.37c5.09.39,8.15.34,11.88,1.81C338.06,206.72,339.4,206.63,342.63,206.43Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.28,204.43S363,185.55,363.94,181s1.81-9.78,10.18-11.93l5.93,17.23s-5.29,16.41-7.95,23.94c-1.93,5.46-1.77,6.76-6.39,6.83s-15.08-.32-15.08-.32c.46-4.13-.1-9.2-1.67-10.92Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--back-box--inject-11"
  }, _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    points: "306.45 225.56 337.57 207.6 368.69 225.56 337.57 243.53 306.45 225.56"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "337.57 207.6 337.57 172.04 305.72 190.43 336.45 208.24 337.57 207.6",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.57 172.04 337.57 207.6 338.68 208.24 369.41 190.43 337.57 172.04",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--front-box--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "305.72 190.43 305.72 225.14 337.57 243.53 337.57 208.88 305.72 190.43",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.57 208.88 337.57 243.53 369.41 225.14 369.41 190.43 337.57 208.88",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.57 208.88 338.29 242.2 364.97 227.71 337.57 243.53 337.57 208.88",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M342,232.38a.72.72,0,0,1-.38-.1,1.14,1.14,0,0,1-.47-1v-3.07h0v-.23l.16,0,2.4-1.42V230a2.76,2.76,0,0,1-1.18,2.24A1,1,0,0,1,342,232.38Zm-.46-4v2.84a.8.8,0,0,0,.27.71.55.55,0,0,0,.53-.06,2.44,2.44,0,0,0,1-1.91v-.25h-.89l-.18-1.2Zm1.23.95h.56v-2.12l-1.44.84.71.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.39,234.83a.2.2,0,0,1-.19-.19v-2.58a.2.2,0,1,1,.39,0v2.58A.2.2,0,0,1,342.39,234.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.27,235.48a.22.22,0,0,1-.17-.1.19.19,0,0,1,.08-.26l2.24-1.3a.19.19,0,0,1,.26.07.21.21,0,0,1-.07.27l-2.24,1.29A.17.17,0,0,1,341.27,235.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.26,231a.36.36,0,0,1-.21-.05.49.49,0,0,1-.23-.46V230a.19.19,0,1,1,.38,0v.53c0,.08,0,.12,0,.13a.26.26,0,0,0,.13,0,1.12,1.12,0,0,0,.35-.87v-3.43a.19.19,0,0,1,.2-.19.19.19,0,0,1,.19.19v3.43a1.44,1.44,0,0,1-.55,1.2A.58.58,0,0,1,349.26,231Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.23,228v-.34a5.44,5.44,0,0,1,2.46-4.27,1.63,1.63,0,0,1,2.67,1.53v.11Zm3.62-4.58a1.94,1.94,0,0,0-1,.3,5.08,5.08,0,0,0-2.26,3.6l4.34-2.51a1.42,1.42,0,0,0-.6-1.26A1,1,0,0,0,350.85,223.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.19,227.08a.18.18,0,0,1-.19-.19v-6.57a.19.19,0,0,1,.38,0v6.57A.18.18,0,0,1,356.19,227.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.63,221.82l-.08,0a.19.19,0,0,1-.1-.25l.69-1.59.76.89a.19.19,0,1,1-.29.25l-.36-.42-.45,1A.18.18,0,0,1,355.63,221.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,226.07a.2.2,0,0,1-.2-.2V219.3a.2.2,0,0,1,.2-.19.2.2,0,0,1,.19.19v6.57A.2.2,0,0,1,358,226.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.41,220.8h-.08a.21.21,0,0,1-.1-.26l.69-1.59.77.89a.19.19,0,0,1,0,.27.2.2,0,0,1-.28,0l-.36-.42-.44,1A.2.2,0,0,1,357.41,220.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.59,215.07l10,5.79a1,1,0,0,1,.45.79v7c0,.57-.41.81-.9.52l-10-5.79a1,1,0,0,1-.45-.79v-7C312.69,215,313.09,214.78,313.59,215.07Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.34 216.16 313.68 216.35 313.68 222.5 313.34 222.31 313.34 216.16",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.73 216.96 315.32 217.3 315.32 223.46 314.73 223.11 314.73 216.96",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.12 217.76 316.46 217.96 316.46 224.11 316.12 223.91 316.12 217.76",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.17 218.35 317.85 218.76 317.85 224.91 317.17 224.5 317.17 218.35",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.9 219.36 319.24 219.56 319.24 225.71 318.89 225.51 318.9 219.36",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.9 219.93 320.63 220.36 320.63 226.51 319.9 226.08 319.9 219.93",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.67 220.97 322.01 221.16 322.01 227.31 321.67 227.12 321.67 220.97",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.47 221.42 322.64 221.51 322.64 227.67 322.47 227.57 322.47 221.42",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.04 220.63 321.21 220.73 321.21 226.88 321.04 226.78 321.04 220.63",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.24 218.99 318.41 219.09 318.41 225.24 318.24 225.14 318.24 218.99",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.71 218.11 316.88 218.21 316.88 224.36 316.71 224.26 316.71 218.11",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.61 217.5 315.78 217.6 315.78 223.75 315.61 223.66 315.61 217.5",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.12 216.6 314.29 216.7 314.29 222.85 314.12 222.75 314.12 216.6",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.06 221.77 323.4 221.96 323.4 228.12 323.06 227.92 323.06 221.77",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "337.57 172.04 305.72 190.43 337.57 208.88 369.41 190.43 337.57 172.04",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.72 190.43 337.57 207.56 369.41 190.43 337.57 208.88 305.72 190.43",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.87 182.26 351.75 200.66 357.41 197.39 325.54 178.99 319.87 182.26",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.41 197.39 357.41 204.58 356.73 204.19 356.01 205.42 355.3 205 354.59 206.24 353.88 205.82 353.17 207.05 352.46 206.65 351.75 207.87 351.75 200.66 357.41 197.39",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.41 197.39 357.41 204.58 356.73 204.19 356.01 205.42 355.3 205 354.59 206.24 353.88 205.82 353.17 207.05 352.46 206.65 351.75 207.87 351.75 200.66 357.41 197.39",
    style: {
      opacity: 0.25
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Chest--inject-11",
    d: "M399.38,166.75c2.82.58,6.39,1.31,10,2.3a37.26,37.26,0,0,1,9.22,3.43,146.46,146.46,0,0,1-2.73,26.07c-.62,2.85-2.69,10.74-3,16.78a95.65,95.65,0,0,0,.51,18.85s-9.31,6.91-29.21,5.41c-15.62-1.17-17.65-6.92-17.65-6.92s.29-26,.69-37.56c.54-15.13,3.62-23.37,7-26l11.75-2.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.12,135.62s2.34.18,3.87,3.12c.76,1.48,1.32,4.17-.79,11.88a31.37,31.37,0,0,1-3.7,8.51,3.81,3.81,0,0,1-2.22,1.76l.16-5.92.22-4.13s-3.33-3-3.62-6a9.5,9.5,0,0,1,1.12-6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.93,135.82c-.58-3.33-4.8-7.3-12.95-7.74-6.67-.36-10.41,2-12.9,5.83-2.77,4.2-.79,8.94-.79,8.94l21-1.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.85,156.7c-3.07,1.49-4.47-.93-4.47-.93L400.92,168c-5.89,7.89-21.62,5-15.17-.87v-2.78a18.71,18.71,0,0,1-2.66-.26c-2.71-.43-4.42-2.59-5.23-5.54a41.2,41.2,0,0,1,0-18.73c.32-1.43.93-3,2.25-3.64,3.26-1.62,6.28.71,10.82,2.48,1.88.73,6.44,1.06,7.65.49-1.59,1.75-1.57,7.28.76,9.53a5.24,5.24,0,0,0,1.17,1.52c1,.86,1.81-1.37,2.64-2.24a3.42,3.42,0,0,1,5.33,1.23A5.57,5.57,0,0,1,405.85,156.7Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.76,164.33A25,25,0,0,0,394.6,163c2.1-.89,4-3.74,4.58-6.56,0,2.27-1,6.3-4.19,8s-6.9,1.76-9.24,1.81Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.06,143.9l3.25.36a1.7,1.7,0,0,0-1.48-1.85A1.6,1.6,0,0,0,390.06,143.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.63,143.11l3.06-1.22a1.59,1.59,0,0,0-2.09-1A1.74,1.74,0,0,0,379.63,143.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.74,147a1.33,1.33,0,1,1-1.28-1.38A1.34,1.34,0,0,1,392.74,147Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.19,146.43a1.33,1.33,0,1,1-1.28-1.38A1.21,1.21,0,0,1,382.19,146.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.35,144.27l-1.1,8.49-4.48-1.66A19.77,19.77,0,0,1,387.35,144.27Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.64,154.65l-3.46,1.14a1.8,1.8,0,0,0,2.27,1.23A1.91,1.91,0,0,0,389.64,154.65Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.28,155.27a2.18,2.18,0,0,1,.44,0,1.8,1.8,0,0,1-1.85,1.87A1.69,1.69,0,0,1,389.28,155.27Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tablet--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372.38,208.7h0l1-.93v0a1.14,1.14,0,0,1,1.05-.16l13.09,3a4.12,4.12,0,0,1,2.58,2.23L399,235.59a1,1,0,0,1-.1,1.18h0l-1,.95h0a1.15,1.15,0,0,1-1.06.17l-13.08-3a4.09,4.09,0,0,1-2.58-2.23c-1.75-4.46-7.15-18.23-8.89-22.68A1,1,0,0,1,372.38,208.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.72,212.19a4,4,0,0,1,1.35,1.64L398,236.51a1.1,1.1,0,0,1-.06,1.16l1-.89h0a1,1,0,0,0,.1-1.18l-8.89-22.69a4,4,0,0,0-1.25-1.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,236.51l-8.89-22.68a4.08,4.08,0,0,0-2.59-2.23l-13.08-3c-1-.24-1.56.37-1.17,1.37,1.74,4.45,7.14,18.22,8.89,22.68a4.09,4.09,0,0,0,2.58,2.23l13.08,3C397.82,238.12,398.35,237.51,398,236.51Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.25,218.65l-1.67-4.24a.74.74,0,0,0-.48-.42l-2.1-.48c-.19,0-.29.07-.22.25l1.67,4.25a.8.8,0,0,0,.48.42l2.1.48C389.22,219,389.32,218.84,389.25,218.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.52,215.44a2,2,0,0,0-1.23-1c-.5-.11-.76.16-.59.61a2,2,0,0,0,1.23,1C387.44,216.16,387.7,215.89,387.52,215.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.33,217.58a1.87,1.87,0,0,0-1.23-1c-.5-.12-.76.15-.58.61a1.87,1.87,0,0,0,1.23,1C388.25,218.31,388.51,218,388.33,217.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.35,221.31l.54,1.39a34.4,34.4,0,0,1-6,1c-.69,0-3.27-1.21-5.37-1.75s-3.45.71-2.37,1.55a14.35,14.35,0,0,0,1.83,1.27c-.88.88-1.49,1.7.29,3.2a2.35,2.35,0,0,0,.75,2.62,22.06,22.06,0,0,0,5.93,3.74c1.15.45,7.16.06,7.67-.22a37.89,37.89,0,0,0,4.57-3.19,33.81,33.81,0,0,1,6.08-3.37c1.83-.61,18.14-7.35,21-8.82s7.53-4.62,3.63-7.69-9.9-4.9-14.6-1.86c-3.41,2.2-12,7-15.88,9.26a4.85,4.85,0,0,1-3.48.72,25.67,25.67,0,0,0-5.42.08Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.66,170.6c7.46,2.14,9.72,3.47,11.25,7.51,2.48,6.57,8.17,29.06,8.48,34.93.16,2.89-13.77,3.37-13.77,3.37l-2.32-7.26s-4.81-16.41-5.9-19.88C410.16,185.35,408.73,174.4,413.66,170.6Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,224.74c.86.49,1.68,1,2.5,1.55.42.26.82.54,1.23.81a1.05,1.05,0,0,0,.57.24c.23,0,.46.06.7.08,1.93.14,3.89.14,5.84.3-1,.1-1.95.15-2.93.18a28.84,28.84,0,0,1-2.94-.05,6.39,6.39,0,0,1-.75-.09,1.54,1.54,0,0,1-.41-.12,2.24,2.24,0,0,1-.34-.22c-.39-.29-.79-.57-1.17-.87C383.49,226,382.72,225.38,382,224.74Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.26,227.94c.81.55,1.61,1.1,2.44,1.61.42.25.83.51,1.25.75.21.11.42.25.63.35a2.65,2.65,0,0,0,.64.14c.94.13,1.92.15,2.89.2s2,.07,2.93.18a32.06,32.06,0,0,1-5.88.05,2.68,2.68,0,0,1-.78-.19c-.23-.12-.43-.25-.64-.38-.42-.26-.83-.53-1.23-.82A19.4,19.4,0,0,1,382.26,227.94Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.59,231.83c.67.27,1.31.56,2,.79a9.6,9.6,0,0,0,2,.49,13.18,13.18,0,0,0,2.09,0,11.83,11.83,0,0,1,2.14.13l-2.12.24a8.67,8.67,0,0,1-2.16,0A9,9,0,0,1,384.59,231.83Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.47,170.25c3.95,1.18,8.34,2.19,10.06,4.47s2.82,5.31,5.22,14.75,4.92,18.43,5,22.8-.91,4.49-5.39,6.86-13.67,5.41-13.67,5.41.39-7.57-6.49-10l8.75-5.35s-5.18-16.66-6.08-19.3S407.68,173.59,413.47,170.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417,209.15c2.32-1.35,5-3.08,8-2.64-1.86-1.29-5.87-.81-8.51,1.08Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cap--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.27,136.77h.1c6-.79,13.05,1.05,18.66,4.5l.55.34.14.11a25.06,25.06,0,0,1,6.34,5.68,3.73,3.73,0,0,1,3,.2c.11-.35.47-1.84.52-2.12.95-5.52,2-12.12-10.26-17.06-8.29-3.33-15.9-1.19-17.88,4C379,133.51,378.66,135.6,378.27,136.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,140.48a17.75,17.75,0,0,0-6.34-6.94c-3-2.06-9.64-2.84-12.61-3.1-5.19-.46-6.55.52-6.69,1.27,0,.18-.2,1-.24,1.2a.78.78,0,0,0,.06.51c.65,1.25,4.63,3.73,4.63,3.73,6.67-1.12,14.65.77,20.94,4.56Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.72,141.71a34.24,34.24,0,0,0-20.94-4.56s-4-2.48-4.63-3.73c-.35-.7.2-2.32,6.63-1.76,3,.27,9.56,1.05,12.6,3.1A17.74,17.74,0,0,1,397.72,141.71Z",
    style: {
      fill: "#37474f"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Scooter--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--scooter--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.11,354.66h0c-2.75-9-14-16.39-24.44-13.45h0a20,20,0,0,0-4.72,2c-10.16,5.86-18.4,20.13-18.4,31.87a19.4,19.4,0,0,0,.82,5.83h0c2.74,9,13.95,16.34,24.43,13.41h0a19.72,19.72,0,0,0,4.71-2c10.17-5.87,18.4-20.13,18.4-31.87A19.16,19.16,0,0,0,458.11,354.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.52,392.31c10.17-5.87,18.4-20.13,18.4-31.87s-8.23-16.49-18.4-10.63-18.4,20.13-18.4,31.87S430.36,398.18,440.52,392.31Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.31,391.28c-6.22,0-6.7-7.4-6.7-9.66,0-10.44,7.63-23.65,16.65-28.86a13.51,13.51,0,0,1,6.48-2c6.22,0,6.7,7.39,6.7,9.66,0,10.42-7.63,23.64-16.66,28.85a13.4,13.4,0,0,1-6.47,2Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.57,386h0c-4.81,0-5.18-5.6-5.18-7.32,0-7.67,5.6-17.38,12.24-21.2a10,10,0,0,1,4.85-1.53c4.81,0,5.18,5.61,5.18,7.33,0,7.66-5.6,17.37-12.24,21.2A10,10,0,0,1,434.57,386Zm11.91-29.41a9.43,9.43,0,0,0-4.53,1.44C435.48,361.78,430,371.23,430,378.7c0,1.57.33,6.69,4.55,6.69A9.43,9.43,0,0,0,439.1,384c6.46-3.74,11.92-13.19,11.92-20.65C451,361.73,450.7,356.61,446.48,356.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.52,362.83c3.91-2.26,7.08-.43,7.08,4.08a15.64,15.64,0,0,1-7.08,12.26c-3.9,2.26-7.07.43-7.07-4.09A15.64,15.64,0,0,1,440.52,362.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.52,368.2c1.34-.77,2.43-.15,2.43,1.4a5.38,5.38,0,0,1-2.43,4.2c-1.34.77-2.42.14-2.42-1.4A5.34,5.34,0,0,1,440.52,368.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.84,389.51l-31.14-18s-27.2,26.61-40.14,22.59c0,0-3.29,34.48,12,37.44s35.3-15.74,42.63-23.3S419.84,389.51,419.84,389.51Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.84,389.51l-31.14-18s-27.2,26.61-40.14,22.59c0,0-3.29,34.48,12,37.44s35.3-15.74,42.63-23.3S419.84,389.51,419.84,389.51Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452,334.19c-3-1.74-14.19-8.19-17.11-9.88a20.56,20.56,0,0,0-20.77,0l-17.33,9.84c-7.45,4.31-22.21,12.68-23.18,21.24-1.27,11.14,8.32,27.95-1.93,39l17,9.81,73.6-45.76v-6.33h0A20.63,20.63,0,0,0,452,334.19Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.31,374.89c-.92-5.31-4.46-11.88-9.13-14.58l-.08,0c-4.67-2.7-8.69-.49-7.77,4.82,1.7,9.84,5,21.15-2.61,29.32l17,9.81C396.27,396,393,384.74,391.31,374.89Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.13,334.12,413.82,344c-7.46,4.31-22.21,12.69-23.19,21.24-1.27,11.15,8.32,28-1.93,39l73.6-45.76v-6.33A20.79,20.79,0,0,0,431.13,334.12Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.24,335.92c-5-2.85-11.91-3.61-21.11,1.25q-.31.15-.63.33l-.7.39c-12.56,7.24-22.73,24.86-22.73,39.36,0,.27,0,.55,0,.83a9.15,9.15,0,0,0,4.59,7.56h0a9.19,9.19,0,0,0,9.2,0L431,379.82l29.35-16.95h0l12-6.9s-3.14-10.27-11.33-15C459.58,340.14,453.81,336.81,452.24,335.92Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,386.85a9.24,9.24,0,0,0,3.81-.67,9.21,9.21,0,0,1-12.71-8.1c0-.29,0-.56,0-.83,0-8.08,3.16-17.13,8.13-24.81l8.5,4.91c-5,7.68-8.13,16.73-8.13,24.81A26.42,26.42,0,0,0,416,386.85Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.26,355.94h0l0-.06v0l0-.11,0,0c0-.11-.08-.25-.14-.42h0c0-.08-.06-.17-.1-.26v0c0-.09-.07-.19-.11-.29v0c-.14-.35-.3-.75-.5-1.2v0c-.07-.14-.13-.29-.2-.44v0c-.23-.48-.48-1-.77-1.57h0l-.3-.56h0c-.42-.77-.9-1.58-1.45-2.41h0a30.86,30.86,0,0,0-1.85-2.5h0a25.51,25.51,0,0,0-2.28-2.39h0a20.41,20.41,0,0,0-2.71-2.11h0c-.24-.15-.48-.3-.73-.44l-.09-.06-.19-.11c-5-2.81-11.9-3.54-21,1.29l-.64.34-.7.39c-12.55,7.24-22.73,24.85-22.73,39.36a25.67,25.67,0,0,0,.42,4.7,9.24,9.24,0,0,0,4.89-1.22L431,379.82l29.35-16.95h0l12-6.9Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.59,340.74c-5-2.77-11.85-3.48-20.95,1.33l-.64.34-.7.39c-5.56,3.2-10.66,8.44-14.6,14.55l-8.5-4.91c3.94-6.1,9-11.34,14.6-14.55l.7-.39q.31-.18.63-.33c9.2-4.86,16.09-4.1,21.11-1.25C453.7,336.75,458.8,339.69,460.59,340.74Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.89,348.54v-1.22a3.7,3.7,0,0,1,1.44-2.73l28.26-19.28a3,3,0,0,1,2.94-.11l19.63,11.33a3.32,3.32,0,0,1,1.51,2.62v4.49a3.31,3.31,0,0,1-1.51,2.61L393,362.49a3.35,3.35,0,0,1-3,0L370.4,351.16A3.32,3.32,0,0,1,368.89,348.54Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.4,346.45,390,357.78a3,3,0,0,0,3-.11l28.26-19.28a1,1,0,0,0-.07-1.86L401.53,325.2a3,3,0,0,0-2.94.11l-28.26,19.28A1,1,0,0,0,370.4,346.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.53,358.1v4.75a3.12,3.12,0,0,1-1.51-.36L370.4,351.16a3.33,3.33,0,0,1-1.52-2.62v-1.22a3.79,3.79,0,0,1,1.3-2.62,1,1,0,0,0,.22,1.75L390,357.78A2.82,2.82,0,0,0,391.53,358.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.56,341.6V306.06L453,294.25a7.2,7.2,0,0,1,10.8,6.23v23.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.56 306.06 432.56 341.6 401.3 323.55 401.3 288.01 432.56 306.06",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.56 337.99 432.56 333.18 401.3 315.13 401.3 319.94 432.56 337.99",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.56 337.99 432.56 333.18 401.3 315.13 401.3 319.94 432.56 337.99",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429,276.2a7.13,7.13,0,0,0-7.2,0L401.3,288l31.26,18.05L453,294.25a7.12,7.12,0,0,1,7.17,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436,337a.42.42,0,0,1-.06-.28v-7a.82.82,0,0,1,.06-.35.43.43,0,0,1,.19-.21l1.33-.76c.61-.36,1.07-.31,1.38.16a5.45,5.45,0,0,1,.46,2.7,9.58,9.58,0,0,1-.46,3.23,3.27,3.27,0,0,1-1.38,1.75l-1.33.77C436.1,337.05,436,337.05,436,337Zm1.49-2a1.69,1.69,0,0,0,.66-1,8.43,8.43,0,0,0,.22-2.17,5.66,5.66,0,0,0-.22-1.92q-.22-.5-.66-.24l-.56.32v5.34Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.2,334.59a.46.46,0,0,1-.06-.29v-7a.85.85,0,0,1,.06-.35.41.41,0,0,1,.19-.2l2.13-1.23c.07,0,.11,0,.14,0a.86.86,0,0,1,0,.34v.29a1.27,1.27,0,0,1,0,.39.31.31,0,0,1-.14.2l-1.41.82v1.94l1.26-.72a.08.08,0,0,1,.14,0,.88.88,0,0,1,0,.34v.29a1.41,1.41,0,0,1,0,.39.38.38,0,0,1-.14.2l-1.26.72v2.13l1.42-.81c.06,0,.1,0,.13,0a.83.83,0,0,1,0,.34v.29a1.3,1.3,0,0,1,0,.4.34.34,0,0,1-.13.19l-2.14,1.23C440.3,334.62,440.24,334.63,440.2,334.59Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.53,332.67a.48.48,0,0,1-.06-.29v-7.13a.63.63,0,0,1,.37-.54l.23-.13a.36.36,0,0,1,.28-.08c.06,0,.09.08.09.19V331l1.24-.72c.07,0,.12,0,.14,0a.83.83,0,0,1,.05.34v.29a1.37,1.37,0,0,1-.05.39.3.3,0,0,1-.14.2l-2,1.13C443.63,332.7,443.57,332.71,443.53,332.67Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.44,330.78v-7.25a.66.66,0,0,1,.37-.55l.24-.14c.25-.13.37-.09.37.13v7.24a.61.61,0,0,1-.37.55l-.24.14C446.57,331,446.44,331,446.44,330.78Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.14,329.33,448,322.74a1.23,1.23,0,0,1,0-.18.35.35,0,0,1,.09-.21,1,1,0,0,1,.29-.23l.22-.13c.21-.12.32-.09.35.07l.74,4.95.06.67h0l.06-.75.76-5.82a.7.7,0,0,1,.36-.48l.2-.11c.26-.15.38-.15.38,0a1,1,0,0,1,0,.21l-1.16,7.93a.63.63,0,0,1-.35.42l-.48.27C449.28,329.47,449.16,329.46,449.14,329.33Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.11,327.71a.42.42,0,0,1-.06-.28v-7a.82.82,0,0,1,.06-.35.43.43,0,0,1,.19-.21l2.12-1.23c.07,0,.12,0,.15,0a.88.88,0,0,1,0,.34v.29a1.41,1.41,0,0,1,0,.39.35.35,0,0,1-.15.2l-1.4.81v1.95l1.25-.72q.11-.06.15,0a.91.91,0,0,1,0,.34v.29a1.33,1.33,0,0,1,0,.39.29.29,0,0,1-.15.2l-1.25.73V326l1.41-.82a.1.1,0,0,1,.14,0,.94.94,0,0,1,0,.35v.29a1.33,1.33,0,0,1,0,.39.34.34,0,0,1-.14.2l-2.13,1.23C452.21,327.75,452.15,327.76,452.11,327.71Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.36,325.63V318.5a.7.7,0,0,1,.07-.35.45.45,0,0,1,.19-.22l1.17-.67c1-.57,1.46-.14,1.46,1.28a3.79,3.79,0,0,1-.68,2.29v.05c.19.05.36.36.5.93l.43,1.91,0,.07v.07q0,.25-.39.48l-.21.12c-.23.14-.35.12-.38,0l-.4-1.93a.77.77,0,0,0-.2-.41c-.07,0-.19,0-.35.06l-.26.15v2.77a.64.64,0,0,1-.39.55l-.2.11C455.49,325.88,455.36,325.84,455.36,325.63Zm1.48-5a1,1,0,0,0,.34-.5,2.68,2.68,0,0,0,.14-.89,1.26,1.26,0,0,0-.14-.71c-.09-.12-.21-.13-.37,0l-.49.29v2.15Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.81,323.06v-3.14l-1.15-3.29a.52.52,0,0,1-.06-.22c0-.15.13-.29.38-.44l.29-.17a.58.58,0,0,1,.25-.09c.06,0,.1,0,.11.09l.69,2.49L461,315a.42.42,0,0,1,.11-.22,1.8,1.8,0,0,1,.25-.18l.23-.13c.27-.16.4-.16.4,0a1.23,1.23,0,0,1-.05.28l-1.16,4.67v3.1a.63.63,0,0,1-.37.54l-.23.13C459.94,323.31,459.81,323.27,459.81,323.06Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436,337a.42.42,0,0,1-.06-.28v-7a.82.82,0,0,1,.06-.35.43.43,0,0,1,.19-.21l1.33-.76c.61-.36,1.07-.31,1.38.16a5.45,5.45,0,0,1,.46,2.7,9.58,9.58,0,0,1-.46,3.23,3.27,3.27,0,0,1-1.38,1.75l-1.33.77C436.1,337.05,436,337.05,436,337Zm1.49-2a1.69,1.69,0,0,0,.66-1,8.43,8.43,0,0,0,.22-2.17,5.66,5.66,0,0,0-.22-1.92q-.22-.5-.66-.24l-.56.32v5.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.2,334.59a.46.46,0,0,1-.06-.29v-7a.85.85,0,0,1,.06-.35.41.41,0,0,1,.19-.2l2.13-1.23c.07,0,.11,0,.14,0a.86.86,0,0,1,0,.34v.29a1.27,1.27,0,0,1,0,.39.31.31,0,0,1-.14.2l-1.41.82v1.94l1.26-.72a.08.08,0,0,1,.14,0,.88.88,0,0,1,0,.34v.29a1.41,1.41,0,0,1,0,.39.38.38,0,0,1-.14.2l-1.26.72v2.13l1.42-.81c.06,0,.1,0,.13,0a.83.83,0,0,1,0,.34v.29a1.3,1.3,0,0,1,0,.4.34.34,0,0,1-.13.19l-2.14,1.23C440.3,334.62,440.24,334.63,440.2,334.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.53,332.67a.48.48,0,0,1-.06-.29v-7.13a.63.63,0,0,1,.37-.54l.23-.13a.36.36,0,0,1,.28-.08c.06,0,.09.08.09.19V331l1.24-.72c.07,0,.12,0,.14,0a.83.83,0,0,1,.05.34v.29a1.37,1.37,0,0,1-.05.39.3.3,0,0,1-.14.2l-2,1.13C443.63,332.7,443.57,332.71,443.53,332.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.44,330.78v-7.25a.66.66,0,0,1,.37-.55l.24-.14c.25-.13.37-.09.37.13v7.24a.61.61,0,0,1-.37.55l-.24.14C446.57,331,446.44,331,446.44,330.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.14,329.33,448,322.74a1.23,1.23,0,0,1,0-.18.35.35,0,0,1,.09-.21,1,1,0,0,1,.29-.23l.22-.13c.21-.12.32-.09.35.07l.74,4.95.06.67h0l.06-.75.76-5.82a.7.7,0,0,1,.36-.48l.2-.11c.26-.15.38-.15.38,0a1,1,0,0,1,0,.21l-1.16,7.93a.63.63,0,0,1-.35.42l-.48.27C449.28,329.47,449.16,329.46,449.14,329.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.11,327.71a.42.42,0,0,1-.06-.28v-7a.82.82,0,0,1,.06-.35.43.43,0,0,1,.19-.21l2.12-1.23c.07,0,.12,0,.15,0a.88.88,0,0,1,0,.34v.29a1.41,1.41,0,0,1,0,.39.35.35,0,0,1-.15.2l-1.4.81v1.95l1.25-.72q.11-.06.15,0a.91.91,0,0,1,0,.34v.29a1.33,1.33,0,0,1,0,.39.29.29,0,0,1-.15.2l-1.25.73V326l1.41-.82a.1.1,0,0,1,.14,0,.94.94,0,0,1,0,.35v.29a1.33,1.33,0,0,1,0,.39.34.34,0,0,1-.14.2l-2.13,1.23C452.21,327.75,452.15,327.76,452.11,327.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.36,325.63V318.5a.7.7,0,0,1,.07-.35.45.45,0,0,1,.19-.22l1.17-.67c1-.57,1.46-.14,1.46,1.28a3.79,3.79,0,0,1-.68,2.29v.05c.19.05.36.36.5.93l.43,1.91,0,.07v.07q0,.25-.39.48l-.21.12c-.23.14-.35.12-.38,0l-.4-1.93a.77.77,0,0,0-.2-.41c-.07,0-.19,0-.35.06l-.26.15v2.77a.64.64,0,0,1-.39.55l-.2.11C455.49,325.88,455.36,325.84,455.36,325.63Zm1.48-5a1,1,0,0,0,.34-.5,2.68,2.68,0,0,0,.14-.89,1.26,1.26,0,0,0-.14-.71c-.09-.12-.21-.13-.37,0l-.49.29v2.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.81,323.06v-3.14l-1.15-3.29a.52.52,0,0,1-.06-.22c0-.15.13-.29.38-.44l.29-.17a.58.58,0,0,1,.25-.09c.06,0,.1,0,.11.09l.69,2.49L461,315a.42.42,0,0,1,.11-.22,1.8,1.8,0,0,1,.25-.18l.23-.13c.27-.16.4-.16.4,0a1.23,1.23,0,0,1-.05.28l-1.16,4.67v3.1a.63.63,0,0,1-.37.54l-.23.13C459.94,323.31,459.81,323.27,459.81,323.06Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M419.84,389.51s-25.69,25-43.5,35.72l0,6.62c19.51-10.48,43.48-39.07,43.48-39.07Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.34,425.23a35.34,35.34,0,0,1-7.45,3.51c-5.9,1.83-17-4.19-17-30.23a137.77,137.77,0,0,1,5.21-36.67c1.57-5.56-.77-12.26-5.77-15.15l-13-7.52c-5-2.89-11.77-1.39-14.33,3.78a104.39,104.39,0,0,0-10.37,47.33c.21,17.86,6,24.75,10,28.65,4.71,4.59,23,17.3,41.89,16.34a26.08,26.08,0,0,0,10.88-3.42",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.74,418.93c-4.53-9.24-7.16-16.34-18.48-22.88-8.69-5-13.63-2.09-14.5,6,1.92,9.45,5.87,14,8.83,16.88,4.71,4.59,23,17.3,41.89,16.34C357.56,435.27,352.26,428.17,347.74,418.93Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.68,383.32a3.8,3.8,0,0,1-1.67,2.6l-2.64,1.53a1.74,1.74,0,0,1-2.38-.64L328.07,380a6.18,6.18,0,0,1-.7-3.24c.64-5.77,3.26-24.66,11.15-37.47l11.32,6.52S340.65,363.48,338.68,383.32Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.9,382.87a3.78,3.78,0,0,1-1.66,2.61L333.59,387a1.74,1.74,0,0,1-2.37-.64l-3.92-6.79a6.1,6.1,0,0,1-.7-3.24c.64-5.77,3.25-24.67,11.15-37.47l11.32,6.51S339.88,363,337.9,382.87Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.9,382.87a3.78,3.78,0,0,1-1.66,2.61L333.59,387a1.74,1.74,0,0,1-2.37-.64l-3.92-6.79a6.1,6.1,0,0,1-.7-3.24c.64-5.77,3.25-24.67,11.15-37.47l11.32,6.51S339.88,363,337.9,382.87Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.28,377.54a.32.32,0,0,1-.16,0l-7-4.06A.3.3,0,0,1,329,373a.31.31,0,0,1,.43-.12l7,4.06a.31.31,0,0,1,.12.43A.31.31,0,0,1,336.28,377.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.81,379.73a.29.29,0,0,1-.16,0L329.33,376a.32.32,0,1,1,.31-.55l6.33,3.65a.34.34,0,0,1,.12.44A.33.33,0,0,1,335.81,379.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.34,381.91a.29.29,0,0,1-.16,0l-5.63-3.25a.32.32,0,0,1,.32-.55l5.62,3.25a.3.3,0,0,1,.12.43A.32.32,0,0,1,335.34,381.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.86,384.1a.33.33,0,0,1-.16-.05l-4.92-2.84a.31.31,0,0,1-.11-.43.3.3,0,0,1,.43-.12L335,383.5a.32.32,0,0,1,.12.44A.33.33,0,0,1,334.86,384.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.44,385.2l2.62,1.52a3.28,3.28,0,0,1,1.5,2.61,37.29,37.29,0,0,1-.37,4.3,6.6,6.6,0,0,1-6,5.58h-.09a1.23,1.23,0,0,1-1.34-1.39,100,100,0,0,0,2-11.77A1,1,0,0,1,344.44,385.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.07,372.27l-1.89-1.09a1.25,1.25,0,0,0-1.94.82,28.92,28.92,0,0,0-.85,6.07c0,4.19,1.4,7,2.34,8s2.53,1.69,2.51.47a55,55,0,0,1,1-11.67A2.64,2.64,0,0,0,322.07,372.27Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.67,427.73a32.84,32.84,0,0,0,5.69-2.46,37.4,37.4,0,0,1-7.48,3.47c-5.89,1.83-17-4.19-17-30.23a137.77,137.77,0,0,1,5.21-36.67c1.57-5.55-.77-12.26-5.77-15.15-4.1-2.36-8.93-5.16-13-7.52a10.85,10.85,0,0,0-9.64-.6,10.75,10.75,0,0,1,11.43-.41l13,7.53c5,2.88,7.35,9.59,5.78,15.15a137.64,137.64,0,0,0-5.21,36.67C353.69,423.54,364.77,429.56,370.67,427.73Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.67,427.73c-5.9,1.83-17-4.19-17-30.22a137.64,137.64,0,0,1,5.21-36.67,14,14,0,0,0-.19-7.87l-1.77,1a13.88,13.88,0,0,1,.17,7.82,137.77,137.77,0,0,0-5.21,36.67c0,26,11.09,32.06,17,30.23a37.4,37.4,0,0,0,7.48-3.47A32.84,32.84,0,0,1,370.67,427.73Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.12,345.69l-13-7.53a10.75,10.75,0,0,0-11.43.41,10.85,10.85,0,0,1,9.64.6c4.11,2.36,8.94,5.16,13,7.52a12.76,12.76,0,0,1,5.6,7.33l1.77-1A12.68,12.68,0,0,0,353.12,345.69Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.77,423h0c-2.74-9-13.95-16.38-24.43-13.45h0a20.36,20.36,0,0,0-4.72,2c-10.16,5.86-18.4,20.13-18.4,31.87a19,19,0,0,0,.83,5.82h0c2.75,9,13.95,16.35,24.43,13.41h0a20.06,20.06,0,0,0,4.71-2c10.16-5.87,18.4-20.14,18.4-31.87A19.23,19.23,0,0,0,339.77,423Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.18,460.65c10.16-5.87,18.4-20.14,18.4-31.87s-8.24-16.5-18.4-10.64-18.4,20.13-18.4,31.87S312,466.51,322.18,460.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,459.61c-6.21,0-6.7-7.39-6.7-9.66,0-10.43,7.63-23.64,16.66-28.85a13.37,13.37,0,0,1,6.47-2c6.22,0,6.7,7.39,6.7,9.65,0,10.43-7.62,23.64-16.65,28.86a13.51,13.51,0,0,1-6.48,2Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.22,454.36h0c-4.81,0-5.18-5.61-5.18-7.33,0-7.66,5.61-17.37,12.24-21.2a10,10,0,0,1,4.85-1.52c4.81,0,5.19,5.6,5.19,7.32,0,7.66-5.61,17.37-12.25,21.2A10,10,0,0,1,316.22,454.36ZM328.13,425a9.41,9.41,0,0,0-4.53,1.43c-6.46,3.73-11.92,13.19-11.92,20.65,0,1.57.33,6.69,4.54,6.69a9.47,9.47,0,0,0,4.54-1.44c6.46-3.73,11.92-13.19,11.92-20.65C332.68,430.06,332.35,425,328.13,425Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.18,431.16c3.91-2.26,7.08-.43,7.08,4.09a15.66,15.66,0,0,1-7.08,12.26c-3.91,2.25-7.08.42-7.08-4.09A15.66,15.66,0,0,1,322.18,431.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.18,436.53c1.34-.77,2.42-.14,2.42,1.4a5.34,5.34,0,0,1-2.42,4.2c-1.34.78-2.43.15-2.43-1.4A5.38,5.38,0,0,1,322.18,436.53Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337,411.15c-2.51-1.45-11.84-6.67-14.13-8.15-4-2.56-9.63-2.35-15.89,1.27-6.06,3.5-11.53,9.54-15.49,16.44a2.23,2.23,0,0,0,.83,3c3.15,1.8,9.31,5.33,12.64,7.31,3.82,2.26,12.94-3.42,21.91-2.57a15.61,15.61,0,0,1,4.39,1c6,2.34,8.12,3.15,10.39,2.32A2.15,2.15,0,0,0,343,430.1a33.09,33.09,0,0,0,.37-4.81C343.41,418.32,341,413.43,337,411.15Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337,411.15c-2.51-1.45-11.84-6.67-14.13-8.15-4-2.56-9.63-2.35-15.89,1.27a36.94,36.94,0,0,0-8.37,6.78L329.69,429a13.2,13.2,0,0,1,1.58.51c6,2.34,8.12,3.15,10.39,2.32A2.15,2.15,0,0,0,343,430.1a33.09,33.09,0,0,0,.37-4.81C343.41,418.32,341,413.43,337,411.15Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.41,425.29a34.27,34.27,0,0,1-.55,6c-2.88,1.62-4.52,1-11.59-1.76a15.61,15.61,0,0,0-4.39-1c-9-.85-18.09,4.83-21.91,2.57a52.23,52.23,0,0,1,7.6-11,37.9,37.9,0,0,1,9-7.42,22.94,22.94,0,0,1,6.34-2.59,12.4,12.4,0,0,1,9.11,1.06C341,413.43,343.41,418.32,343.41,425.29Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.41,425.29a34.27,34.27,0,0,1-.55,6c-2.88,1.62-4.52,1-11.59-1.76a15.61,15.61,0,0,0-4.39-1c-9-.85-18.09,4.83-21.91,2.57a52.23,52.23,0,0,1,7.6-11,37.9,37.9,0,0,1,9-7.42,22.94,22.94,0,0,1,6.34-2.59,12.4,12.4,0,0,1,9.11,1.06C341,413.43,343.41,418.32,343.41,425.29Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.52,313l2.49-4.31-10.54-6.08h0a1.25,1.25,0,0,0-1.26.11,3.92,3.92,0,0,0-1.76,3.05,1.23,1.23,0,0,0,.5,1.12h0l0,0h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,311.85c0,1.12.78,1.58,1.75,1a3.87,3.87,0,0,0,1.76-3.05c0-1.12-.78-1.57-1.76-1A3.87,3.87,0,0,0,319,311.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.18,315.22l.68-1.18-6.68-3.86h0a.31.31,0,0,0-.34,0,1.06,1.06,0,0,0-.48.83.31.31,0,0,0,.14.3h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,314.91c0,.3.22.43.48.27a1.06,1.06,0,0,0,.48-.83c0-.3-.22-.43-.48-.27A1.06,1.06,0,0,0,327,314.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.45,341.51c-2.17-.09-6.79,1.09-8.33,4.18l-13-7.53s1.39-5.85-7.48-12.69Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.45,341.51c-2.17-.09-6.79,1.09-8.33,4.18l-13-7.53s1.39-5.85-7.48-12.69Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.22 338.31 372.64 345.38 372.64 340.73 356.53 331.43 352.22 338.31",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.56 329.1 376.67 338.41 372.64 340.73 356.53 331.43 360.56 329.1",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.56 329.1 376.67 338.41 372.64 340.73 356.53 331.43 360.56 329.1",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.64 345.38 376.67 343.06 376.67 338.41 372.64 340.73 372.64 345.38",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.64 345.38 376.67 343.06 376.67 338.41 372.64 340.73 372.64 345.38",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.38 321.56 323.27 312.26 327.3 309.93 343.41 319.23 339.38 321.56",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.38 321.56 323.27 312.26 327.3 309.93 343.41 319.23 339.38 321.56",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.27 316.91 335.35 328.54 339.38 321.56 323.27 312.26 323.27 316.91",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.67,325.77a12.37,12.37,0,0,0-2.65-2.19L341.92,316a2.21,2.21,0,0,0-2.65.44l-1.74,2a10.73,10.73,0,0,0-1.71,3l-2.89,8.33a2.18,2.18,0,0,0,.94,2.52L347,339.86a3.35,3.35,0,0,0,3,0l1-.58a7.72,7.72,0,0,0,2.38-2.38l2.29-4a7.51,7.51,0,0,1,2.38-2.38l2.52-1.46Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.67,325.77a12.37,12.37,0,0,0-2.65-2.19L341.92,316a2.21,2.21,0,0,0-2.65.44l-1.74,2a10.73,10.73,0,0,0-1.71,3l-2.89,8.33a2.18,2.18,0,0,0,.94,2.52L347,339.86a3.35,3.35,0,0,0,3,0l1-.58a7.72,7.72,0,0,0,2.38-2.38l2.29-4a7.51,7.51,0,0,1,2.38-2.38l2.52-1.46Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.64,327.79l1.75-2a1.39,1.39,0,0,0-.37-2.19L341.92,316a2.21,2.21,0,0,0-2.65.44l-1.74,2a1.38,1.38,0,0,0,.37,2.19L351,328.23A2.21,2.21,0,0,0,353.64,327.79Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.93,330.75,349,339.09a1.39,1.39,0,0,1-2.08.77l-13.09-7.56a2.18,2.18,0,0,1-.94-2.52l2.89-8.33a1.38,1.38,0,0,1,2.08-.78L351,328.23A2.19,2.19,0,0,1,351.93,330.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.66,338.65l-13.1-7.56a.79.79,0,0,1-.31-.85l2.88-8.34,0,0,13.13,7.59a.8.8,0,0,1,.32.85l-2.88,8.34s0,0,0,.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.75,323.24l-2.42,7.13,11.7,6.84.5-1.32s-6.38-3.23-8.15-5.62S337.75,323.24,337.75,323.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.09,315a.7.7,0,0,1-.67-.49l-2-6.63-9.67-5.58a.65.65,0,0,1-.32-.39l-2.52-8.11a.7.7,0,1,1,1.34-.41l2.43,7.84,9.67,5.58a.71.71,0,0,1,.32.4l2.12,6.88a.7.7,0,0,1-.46.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.78,288.78,316.91,286a1.26,1.26,0,0,0-1.29-.13c-.24.15-1.2.68-1.45.84a1.32,1.32,0,0,0-.49,1.15v2.35a4,4,0,0,0,1.82,3.14l4.87,2.81a1.26,1.26,0,0,0,1.26.14c.26-.14,1.18-.69,1.43-.83a1.25,1.25,0,0,0,.53-1.17v-2.36A4,4,0,0,0,321.78,288.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.5,293.32l4.87,2.81c1,.58,1.81.11,1.81-1v-2.36a4,4,0,0,0-1.81-3.14l-4.87-2.81c-1-.57-1.81-.11-1.81,1.05v2.35A4,4,0,0,0,315.5,293.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.52,330.89a1,1,0,0,1-1.53.63,1.64,1.64,0,0,1-.65-1.88,1,1,0,0,1,1.52-.63A1.63,1.63,0,0,1,343.52,330.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.24,346.38l.68-1.17-6.69-3.87h0a.33.33,0,0,0-.34,0,1.07,1.07,0,0,0-.48.83.35.35,0,0,0,.13.31h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.1,346.07c0,.31.21.43.48.28a1.08,1.08,0,0,0,.48-.83c0-.31-.22-.43-.48-.28A1.05,1.05,0,0,0,381.1,346.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.71,352.78l2.5-4.31-10.54-6.08h0a1.25,1.25,0,0,0-1.26.11,3.9,3.9,0,0,0-1.76,3.05,1.25,1.25,0,0,0,.49,1.12h0l0,0h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.2,351.64c0,1.12.79,1.58,1.76,1a3.9,3.9,0,0,0,1.76-3.05c0-1.12-.79-1.57-1.76-1A3.88,3.88,0,0,0,388.2,351.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,341.49a.67.67,0,0,1-.34-.09L371.31,332l-1.79,3.75a.7.7,0,1,1-1.26-.6l2.12-4.43a.7.7,0,0,1,.42-.37.73.73,0,0,1,.56.06l16.33,9.43,1.8-3.75a.69.69,0,0,1,.93-.33.71.71,0,0,1,.33.93l-2.13,4.43a.67.67,0,0,1-.42.37A.76.76,0,0,1,388,341.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,330.45l-4.87-2.82a1.28,1.28,0,0,0-1.29-.12c-.24.14-1.2.67-1.45.84a1.31,1.31,0,0,0-.49,1.15v2.35a4,4,0,0,0,1.81,3.14l4.87,2.81a1.25,1.25,0,0,0,1.27.13l1.43-.82a1.26,1.26,0,0,0,.53-1.17v-2.36A4,4,0,0,0,394,330.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.68,335l4.87,2.81c1,.58,1.81.11,1.81-1.05V334.4a4,4,0,0,0-1.81-3.14l-4.87-2.81c-1-.58-1.81-.11-1.81,1.05v2.35A4,4,0,0,0,387.68,335Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.16,158.51l-6.1-3.59a1.8,1.8,0,0,1-.75-.88l-2.11-5.26,4.37-2.52-.13.39Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.16,158.51l-6.1-3.59a1.8,1.8,0,0,1-.75-.88l-2.11-5.26,4.37-2.52-.13.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.28,42.49a7.87,7.87,0,0,0-3.56-6.16l-.78-.47a7.82,7.82,0,0,0-7.11,0L304.45,75.35a7.87,7.87,0,0,0-3.56,6.16v65.18a7.88,7.88,0,0,0,3.56,6.16l.78.47a7.88,7.88,0,0,0,7.11,0l68.71-39.74c3.2-1.82,3.23-3.65,3.23-5.92Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.18,41.47c-.41-1.51-1.81-2-3.46-1l-68.38,39.5a7.06,7.06,0,0,0-2.51,2.65h0a7.41,7.41,0,0,0-1,3.5v65.18c0,2,1.21,3,2.83,2.39l.11,0a3.84,3.84,0,0,0,.61-.3l11.57-6.68,4.84,11.43a1,1,0,0,0,1.83-.12l5.17-18.16,45.3-26.2c3.2-1.82,3.23-3.65,3.23-5.92V42.49A6,6,0,0,0,384.18,41.47Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.32,41c.28,0,.66.08.86.73a4.45,4.45,0,0,1,.07.79v65.17c0,2.18,0,3.49-2.71,5l-45.31,26.2-.36.21-.11.4-5.13,18-4.78-11.28-.45-1.07-1,.58-11.56,6.69a4.78,4.78,0,0,1-.5.24h0a1.55,1.55,0,0,1-.54.1c-.85,0-.94-1.06-.94-1.52V86.08a6.08,6.08,0,0,1,.7-2.61l.22-.39a6.11,6.11,0,0,1,2.12-2.26l68.38-39.5a2.29,2.29,0,0,1,1.09-.35m0-1a3.27,3.27,0,0,0-1.6.48l-68.38,39.5a7.06,7.06,0,0,0-2.51,2.65h0a7.41,7.41,0,0,0-1,3.5v65.18c0,1.61.79,2.55,2,2.55a2.51,2.51,0,0,0,.87-.16l.11,0a3.84,3.84,0,0,0,.61-.3l11.57-6.68,4.84,11.43a1,1,0,0,0,.89.59,1,1,0,0,0,.94-.71l5.17-18.16,45.3-26.2c3.2-1.82,3.23-3.65,3.23-5.92V42.49a6,6,0,0,0-.1-1A1.88,1.88,0,0,0,382.32,40Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.89,146.69a7.88,7.88,0,0,0,3.56,6.16l.78.47a8,8,0,0,0,6.5.3c-1.67.63-2.94-.33-2.94-2.36V86.09a7.21,7.21,0,0,1,1-3.51L301.94,78a7.19,7.19,0,0,0-1.05,3.5Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.18,41.48c-.42-1.51-1.81-2-3.46-1l-68.38,39.5a7.09,7.09,0,0,0-2.51,2.66L302,78a7,7,0,0,1,2.5-2.65l68.37-39.5a7.9,7.9,0,0,1,7.12,0l.78.47A7.86,7.86,0,0,1,384.18,41.48Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M313.53,96.35a.65.65,0,0,1-.07-.36V87.08a1.32,1.32,0,0,1,.07-.45.53.53,0,0,1,.25-.26l1.68-1c.78-.45,1.37-.38,1.75.21A6.8,6.8,0,0,1,317.8,89a11.87,11.87,0,0,1-.59,4.1,4.06,4.06,0,0,1-1.75,2.23l-1.68,1C313.66,96.4,313.58,96.4,313.53,96.35Zm1.89-2.56a2,2,0,0,0,.84-1.28,10.17,10.17,0,0,0,.28-2.76,7,7,0,0,0-.28-2.44c-.18-.41-.46-.52-.84-.3l-.71.41V94.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.87,93.27a.57.57,0,0,1-.07-.36V84a1.06,1.06,0,0,1,.07-.44.55.55,0,0,1,.24-.26l2.7-1.56c.09,0,.15,0,.19,0a1.34,1.34,0,0,1,.05.43v.37a2.2,2.2,0,0,1-.05.5.41.41,0,0,1-.19.25l-1.78,1v2.48l1.59-.92a.11.11,0,0,1,.18,0,1.09,1.09,0,0,1,.06.43v.38a1.63,1.63,0,0,1-.06.49.47.47,0,0,1-.18.26l-1.59.91v2.71l1.79-1c.08,0,.14,0,.18,0a1.37,1.37,0,0,1,.05.44v.37a2,2,0,0,1-.05.5.44.44,0,0,1-.18.25l-2.71,1.56C319,93.32,318.92,93.32,318.87,93.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.1,90.83a.55.55,0,0,1-.08-.36V81.41a.8.8,0,0,1,.47-.68l.29-.17a.6.6,0,0,1,.36-.11c.07,0,.11.11.11.25v8l1.57-.91c.09,0,.15,0,.19,0a1.16,1.16,0,0,1,.05.44v.37a1.67,1.67,0,0,1-.05.49.44.44,0,0,1-.19.26l-2.48,1.43C323.23,90.88,323.15,90.88,323.1,90.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.8,88.43v-9.2a.8.8,0,0,1,.47-.7l.3-.17c.31-.18.46-.13.46.16v9.2a.79.79,0,0,1-.46.69l-.3.18C327,88.77,326.8,88.72,326.8,88.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.22,86.6l-1.47-8.38a1.12,1.12,0,0,1,0-.22.48.48,0,0,1,.12-.28,1.41,1.41,0,0,1,.36-.28l.28-.16c.26-.16.41-.13.44.08l.95,6.29.08.85,0,0,.08-1,1-7.39a.8.8,0,0,1,.45-.6l.26-.15c.32-.19.48-.18.48,0s0,.14,0,.25l-1.49,10.08a.76.76,0,0,1-.44.53l-.61.35C330.4,86.76,330.25,86.76,330.22,86.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,84.54a.57.57,0,0,1-.07-.36V75.26a1.1,1.1,0,0,1,.07-.44.55.55,0,0,1,.24-.26l2.7-1.56c.09,0,.15,0,.19,0a1.34,1.34,0,0,1,.05.43v.37a2.2,2.2,0,0,1-.05.5.41.41,0,0,1-.19.25l-1.78,1V78.1l1.59-.92a.11.11,0,0,1,.18,0,1.11,1.11,0,0,1,.06.44V78a1.66,1.66,0,0,1-.06.5.47.47,0,0,1-.18.26l-1.59.91V82.4l1.79-1c.08,0,.14,0,.18,0a1.25,1.25,0,0,1,.05.43v.37a2,2,0,0,1-.05.5.44.44,0,0,1-.18.25l-2.71,1.56C334.12,84.59,334,84.59,334,84.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.12,81.89v-9a1.17,1.17,0,0,1,.08-.45.65.65,0,0,1,.25-.27l1.49-.86c1.24-.71,1.86-.17,1.86,1.63a4.87,4.87,0,0,1-.87,2.91v.06c.24.07.45.46.63,1.19l.55,2.43s0,0,0,.08,0,.06,0,.08c0,.22-.17.43-.5.62l-.27.16c-.29.16-.45.15-.48,0l-.51-2.44a1,1,0,0,0-.25-.53c-.1-.06-.25,0-.44.07l-.35.2v3.52a.81.81,0,0,1-.49.69l-.24.15C338.28,82.21,338.12,82.17,338.12,81.89ZM340,75.55a1.1,1.1,0,0,0,.43-.63,3.47,3.47,0,0,0,.17-1.12,1.58,1.58,0,0,0-.17-.91c-.11-.15-.27-.16-.47,0l-.63.36v2.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.77,78.63v-4l-1.47-4.17a.68.68,0,0,1-.07-.29c0-.18.16-.36.49-.55l.37-.22a1,1,0,0,1,.31-.12c.08,0,.12,0,.14.12l.88,3.16.87-4.19a.52.52,0,0,1,.15-.27,1.31,1.31,0,0,1,.31-.23l.3-.18c.34-.19.51-.2.51,0a2,2,0,0,1-.07.37L345,74v3.94a.78.78,0,0,1-.47.69l-.29.16C343.93,79,343.77,78.9,343.77,78.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348,76.34s0-.11,0-.25l1.52-10a.9.9,0,0,1,.5-.65l.49-.28q.43-.25.51.06l1.5,8.27a1.41,1.41,0,0,1,0,.23c0,.19-.12.36-.38.51l-.37.21c-.26.15-.41.15-.43,0l-.3-1.78-1.61.93-.29,2.12a.73.73,0,0,1-.4.5l-.37.21C348.09,76.55,348,76.53,348,76.34Zm2.91-5.12-.5-3c-.05-.28-.08-.59-.11-.94l-.05,0c0,.39-.07.75-.11,1.08L349.6,72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.23,73.43a.57.57,0,0,1-.07-.36V64.15a1.1,1.1,0,0,1,.07-.44.55.55,0,0,1,.24-.26l1.69-1c.78-.45,1.37-.38,1.75.21a6.8,6.8,0,0,1,.59,3.43,11.87,11.87,0,0,1-.59,4.1,4.1,4.1,0,0,1-1.75,2.23l-1.69,1C353.36,73.48,353.28,73.48,353.23,73.43Zm1.89-2.56a2,2,0,0,0,.84-1.28,10.17,10.17,0,0,0,.28-2.76,6.92,6.92,0,0,0-.28-2.44q-.27-.63-.84-.3l-.71.41v6.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.57,70.35a.57.57,0,0,1-.07-.36V61.07a1,1,0,0,1,.07-.44.62.62,0,0,1,.24-.27l1.68-1c.79-.45,1.37-.38,1.76.21a6.82,6.82,0,0,1,.58,3.43,11.89,11.89,0,0,1-.58,4.1,4.11,4.11,0,0,1-1.76,2.23l-1.68,1C358.7,70.4,358.62,70.4,358.57,70.35Zm1.89-2.56a2.12,2.12,0,0,0,.84-1.28,10.6,10.6,0,0,0,.28-2.76,7.17,7.17,0,0,0-.28-2.44q-.29-.63-.84-.3l-.72.41V68.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.81,67.06V58a1.12,1.12,0,0,1,.08-.44.55.55,0,0,1,.25-.27l1.49-.86c1.23-.71,1.85-.17,1.85,1.63a4.93,4.93,0,0,1-.86,2.91V61c.24.06.45.46.62,1.19l.56,2.42,0,.09s0,0,0,.08c0,.22-.17.43-.5.62l-.27.15c-.29.17-.45.15-.48,0l-.51-2.44a1.07,1.07,0,0,0-.25-.52c-.1-.07-.25,0-.44.07l-.35.2v3.51a.81.81,0,0,1-.49.7l-.25.14C364,67.38,363.81,67.33,363.81,67.06Zm1.88-6.34a1.1,1.1,0,0,0,.43-.63,3.47,3.47,0,0,0,.17-1.12,1.67,1.67,0,0,0-.17-.91c-.11-.15-.27-.16-.47-.05l-.63.36v2.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.65,64.53a.57.57,0,0,1-.07-.36V55.26a1.12,1.12,0,0,1,.07-.45.55.55,0,0,1,.24-.26l2.7-1.56c.09-.05.15,0,.19,0a1.34,1.34,0,0,1,.05.43v.37a2.2,2.2,0,0,1-.05.5.41.41,0,0,1-.19.25l-1.78,1v2.48l1.59-.92a.11.11,0,0,1,.18,0,1.09,1.09,0,0,1,.06.43V58a1.66,1.66,0,0,1-.06.5.47.47,0,0,1-.18.26l-1.59.91v2.71l1.79-1c.08,0,.14,0,.18,0a1.37,1.37,0,0,1,.05.44v.37a2,2,0,0,1-.05.5.44.44,0,0,1-.18.25l-2.71,1.56C368.78,64.58,368.7,64.58,368.65,64.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.23,61.91a.79.79,0,0,1-.65-.15.67.67,0,0,1-.08-.18.61.61,0,0,1,0-.22,3.39,3.39,0,0,1,.11-.77.83.83,0,0,1,.25-.5.19.19,0,0,1,.18,0l.16,0A1,1,0,0,0,374,60a1.74,1.74,0,0,0,.6-.63,2.09,2.09,0,0,0,.24-1,1.13,1.13,0,0,0-.21-.8,1.55,1.55,0,0,0-.67-.31,2,2,0,0,1-.78-.33,1.44,1.44,0,0,1-.47-.67,3.67,3.67,0,0,1-.17-1.23,5,5,0,0,1,.54-2.32,3.56,3.56,0,0,1,1.39-1.54,2.05,2.05,0,0,1,.65-.24.86.86,0,0,1,.54,0,.33.33,0,0,1,.13.31,3.31,3.31,0,0,1-.11.75c-.06.3-.14.47-.23.52a.48.48,0,0,1-.21,0,1.18,1.18,0,0,0-.69.17,1.41,1.41,0,0,0-.59.64,2,2,0,0,0-.2.85,1.27,1.27,0,0,0,.13.65.58.58,0,0,0,.28.28c.11,0,.31.11.59.19a1.66,1.66,0,0,1,1,.63,2.76,2.76,0,0,1,.32,1.53,6.05,6.05,0,0,1-.23,1.63,4.77,4.77,0,0,1-.68,1.44,3.42,3.42,0,0,1-1.07,1A2.26,2.26,0,0,1,373.23,61.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.27,59.58a.8.8,0,0,1-.65-.16.85.85,0,0,1-.08-.17.61.61,0,0,1,0-.22,3.31,3.31,0,0,1,.11-.77.83.83,0,0,1,.25-.5.19.19,0,0,1,.18,0l.16,0a1,1,0,0,0,.86-.1,1.59,1.59,0,0,0,.6-.63,2,2,0,0,0,.24-1,1.11,1.11,0,0,0-.21-.8,1.44,1.44,0,0,0-.67-.31,2.35,2.35,0,0,1-.78-.33,1.49,1.49,0,0,1-.47-.67,3.67,3.67,0,0,1-.17-1.23,5,5,0,0,1,.54-2.33,3.67,3.67,0,0,1,1.39-1.54,1.81,1.81,0,0,1,.65-.23.86.86,0,0,1,.54,0c.08,0,.13.14.13.31a3.39,3.39,0,0,1-.11.75c-.06.3-.14.47-.23.52a.37.37,0,0,1-.21,0,1.19,1.19,0,0,0-.69.18,1.39,1.39,0,0,0-.59.63,2,2,0,0,0-.2.86,1.29,1.29,0,0,0,.13.65.63.63,0,0,0,.28.28l.59.19a1.6,1.6,0,0,1,1,.62,2.8,2.8,0,0,1,.32,1.54,5.93,5.93,0,0,1-.23,1.62,4.72,4.72,0,0,1-.68,1.45,3.28,3.28,0,0,1-1.07,1A2.29,2.29,0,0,1,377.27,59.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.44 101.39 313.44 144.75 351.03 123.06 351.03 79.69 313.44 101.39",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.44 101.39 313.44 144.75 351.03 123.06 351.03 79.69 313.44 101.39",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351,98.9l-10.24,11.91-2.29-8L351,88.27v-2.4l-13,15.19-1.63-5.66L348.69,81l-4.1,2.36-8.76,10.2-1.27-4.4-1.56.9,1.46,5.09-6.5,7.57,1-1.85a13.14,13.14,0,0,0,1.3-8.91l-.07-.25-1.58.91a13.38,13.38,0,0,1-1.37,8.59l-2.7,5.25-2.84-9.85-1.56.9.17.59-6.82,7.94v2.4l7.34-8.54,2.41,8.36.14.47-.17.33a13.13,13.13,0,0,0-1.3,8.91l.39,1.35-8.81,10.26V132l9.33-10.86,2.3,8-11.63,13.54v2.1l.51-.29,5.18-6,.75,2.61,1.56-.9-.95-3.29,5.09-5.93,1.69,5.86,4.6-2.66,10.31-12,1.46,5.2,1.55-.89-1.64-5.9,7.48-8.71v-2.4l-8,9.3-1.06-3.8-.67-2.31L351,101.3Zm-27.45,18.76a13.11,13.11,0,0,1,1.3-8.9v0l.19-.21L335,97l1.64,5.66-13,15.13Zm.55,1.91,13-15.13,2.29,8-13,15.13Zm17.55.73-13,15.1L327,129.33l13-15.14.67,2.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.64,104.77c0-2.61-1.72-3.74-3.85-2.51a8.8,8.8,0,0,0-3.84,7v.59c0,2,2.28,4.35,3.33,5.32a.52.52,0,0,0,.82-.15c.9-1.86,3.54-7.44,3.54-9.61Zm-3.85,4.15c-1.06.62-1.92.12-1.92-1.11a4.26,4.26,0,0,1,1.92-3.33c1.07-.61,1.93-.12,1.93,1.11A4.22,4.22,0,0,1,330.79,108.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.14,82.9a.77.77,0,0,1-.39-1.44l23-13.29a.77.77,0,0,1,.77,1.34l-23,13.29A.75.75,0,0,1,355.14,82.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.14,87.72a.77.77,0,0,1-.39-1.44l23-13.29a.77.77,0,0,1,.77,1.34l-23,13.29A.75.75,0,0,1,355.14,87.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.14,97.36a.77.77,0,0,1-.39-1.44l23-13.29a.77.77,0,0,1,.77,1.34l-23,13.28A.76.76,0,0,1,355.14,97.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.14,102.18a.77.77,0,0,1-.39-1.44l23-13.29a.77.77,0,0,1,.77,1.34l-23,13.28A.76.76,0,0,1,355.14,102.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.14,107a.77.77,0,0,1-.39-1.44l23-13.29a.77.77,0,0,1,.77,1.34l-23,13.28A.76.76,0,0,1,355.14,107Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.14,111.82a.77.77,0,0,1-.39-1.44l23-13.29a.77.77,0,1,1,.77,1.33l-23,13.29A.76.76,0,0,1,355.14,111.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.14,116.63a.76.76,0,0,1-.67-.38.77.77,0,0,1,.28-1l23-13.29a.77.77,0,1,1,.77,1.33l-23,13.29A.75.75,0,0,1,355.14,116.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryaddressAmico);
export default __webpack_public_path__ + "static/media/Delivery address-amico.e9fffc662c40ec9a5eb3f103e16d3ee5.svg";
export { ForwardRef as ReactComponent };